(() => {
  "use strict";
  function t(t, e) {
    var i = Object.keys(t);
    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(t);
      e &&
        (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })),
        i.push.apply(i, n);
    }
    return i;
  }
  function e(e) {
    for (var n = 1; n < arguments.length; n++) {
      var s = null != arguments[n] ? arguments[n] : {};
      n % 2
        ? t(Object(s), !0).forEach(function (t) {
            i(e, t, s[t]);
          })
        : Object.getOwnPropertyDescriptors
        ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(s))
        : t(Object(s)).forEach(function (t) {
            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(s, t));
          });
    }
    return e;
  }
  function i(t, e, i) {
    return (
      (e = f(e)) in t
        ? Object.defineProperty(t, e, {
            value: i,
            enumerable: !0,
            configurable: !0,
            writable: !0,
          })
        : (t[e] = i),
      t
    );
  }
  function n(t, e, i) {
    return (
      (e = r(e)),
      s(
        t,
        a() ? Reflect.construct(e, i || [], r(t).constructor) : e.apply(t, i)
      )
    );
  }
  function s(t, e) {
    if (e && ("object" == u(e) || "function" == typeof e)) return e;
    if (void 0 !== e)
      throw new TypeError(
        "Derived constructors may only return object or undefined"
      );
    return o(t);
  }
  function o(t) {
    if (void 0 === t)
      throw new ReferenceError(
        "this hasn't been initialised - super() hasn't been called"
      );
    return t;
  }
  function a() {
    try {
      var t = !Boolean.prototype.valueOf.call(
        Reflect.construct(Boolean, [], function () {})
      );
    } catch (t) {}
    return (a = function e() {
      return !!t;
    })();
  }
  function r(t) {
    return (
      (r = Object.setPrototypeOf
        ? Object.getPrototypeOf.bind()
        : function (t) {
            return t.__proto__ || Object.getPrototypeOf(t);
          }),
      r(t)
    );
  }
  function l(t, e) {
    if ("function" != typeof e && null !== e)
      throw new TypeError("Super expression must either be null or a function");
    (t.prototype = Object.create(e && e.prototype, {
      constructor: { value: t, writable: !0, configurable: !0 },
    })),
      Object.defineProperty(t, "prototype", { writable: !1 }),
      e && h(t, e);
  }
  function h(t, e) {
    return (
      (h = Object.setPrototypeOf
        ? Object.setPrototypeOf.bind()
        : function (t, e) {
            return (t.__proto__ = e), t;
          }),
      h(t, e)
    );
  }
  function u(t) {
    "@babel/helpers - typeof";
    return (
      (u =
        "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                "function" == typeof Symbol &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            }),
      u(t)
    );
  }
  function c(t, e) {
    if (!(t instanceof e))
      throw new TypeError("Cannot call a class as a function");
  }
  function p(t, e) {
    for (var i = 0; i < e.length; i++) {
      var n = e[i];
      (n.enumerable = n.enumerable || !1),
        (n.configurable = !0),
        "value" in n && (n.writable = !0),
        Object.defineProperty(t, f(n.key), n);
    }
  }
  function d(t, e, i) {
    return (
      e && p(t.prototype, e),
      i && p(t, i),
      Object.defineProperty(t, "prototype", { writable: !1 }),
      t
    );
  }
  function f(t) {
    var e = v(t, "string");
    return "symbol" == u(e) ? e : e + "";
  }
  function v(t, e) {
    if ("object" != u(t) || !t) return t;
    var i = t[Symbol.toPrimitive];
    if (void 0 !== i) {
      var n = i.call(t, e || "default");
      if ("object" != u(n)) return n;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === e ? String : Number)(t);
  }
  /*!
   * PhotoSwipe 5.4.4 - https://photoswipe.com
   * (c) 2024 Dmytro Semenov
   */ function m(t, e, i) {
    var n = document.createElement(e);
    if (t) n.className = t;
    if (i) i.appendChild(n);
    return n;
  }
  function y(t, e) {
    t.x = e.x;
    t.y = e.y;
    if (e.id !== void 0) t.id = e.id;
    return t;
  }
  function g(t) {
    t.x = Math.round(t.x);
    t.y = Math.round(t.y);
  }
  function _(t, e) {
    var i = Math.abs(t.x - e.x);
    var n = Math.abs(t.y - e.y);
    return Math.sqrt(i * i + n * n);
  }
  function w(t, e) {
    return t.x === e.x && t.y === e.y;
  }
  function b(t, e, i) {
    return Math.min(Math.max(t, e), i);
  }
  function x(t, e, i) {
    var n = "translate3d(".concat(t, "px,").concat(e || 0, "px,0)");
    // if (i !== void 0) n += " scale3d(".concat(i, ",").concat(i, ",1)");
    n += " scale3d(1,1,1)";
    return n;
  }
  function S(t, e, i, n) {
    t.style.transform = x(e, i, n);
  }
  var P = "cubic-bezier(.4,0,.22,1)";

  function k(t, e, i, n) {
    t.style.transition = e
      ? ""
          .concat(e, " ")
          .concat(i, "ms ")
          .concat(n || P)
      : "none";
  }

  function I(t, e, i) {
    if (window.innerWidth >= 1600) {
      t.style.width = `52.08vw`;
      t.style.height = `35.15vw`;
    } else {
      t.style.width = typeof e === "number" ? "".concat(e, "px") : e;
      t.style.height = typeof i === "number" ? "".concat(i, "px") : i;
    }
  }

  function C(t) {
    k(t);
  }
  function L(t) {
    if ("decode" in t) return t.decode()["catch"](function () {});
    if (t.complete) return Promise.resolve(t);
    return new Promise(function (e, i) {
      t.onload = function () {
        return e(t);
      };
      t.onerror = i;
    });
  }
  var z = {
    IDLE: "idle",
    LOADING: "loading",
    LOADED: "loaded",
    ERROR: "error",
  };
  function A(t) {
    return (
      ("button" in t && t.button === 1) ||
      t.ctrlKey ||
      t.metaKey ||
      t.altKey ||
      t.shiftKey
    );
  }
  function O(t, e) {
    var i =
      arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : document;
    var n = [];
    if (t instanceof Element) n = [t];
    else if (t instanceof NodeList || Array.isArray(t)) n = Array.from(t);
    else {
      var s = typeof t === "string" ? t : e;
      if (s) n = Array.from(i.querySelectorAll(s));
    }
    return n;
  }
  function T() {
    return !!(navigator.vendor && navigator.vendor.match(/apple/i));
  }
  var E = false;
  try {
    window.addEventListener(
      "test",
      null,
      Object.defineProperty({}, "passive", {
        get: function t() {
          E = true;
        },
      })
    );
  } catch (t) {}
  var D = (function () {
    function t() {
      c(this, t);
      this._pool = [];
    }
    return d(t, [
      {
        key: "add",
        value: function t(e, i, n, s) {
          this._toggleListener(e, i, n, s);
        },
      },
      {
        key: "remove",
        value: function t(e, i, n, s) {
          this._toggleListener(e, i, n, s, true);
        },
      },
      {
        key: "removeAll",
        value: function t() {
          var e = this;
          this._pool.forEach(function (t) {
            e._toggleListener(
              t.target,
              t.type,
              t.listener,
              t.passive,
              true,
              true
            );
          });
          this._pool = [];
        },
      },
      {
        key: "_toggleListener",
        value: function t(e, i, n, s, o, a) {
          var r = this;
          if (!e) return;
          var l = o ? "removeEventListener" : "addEventListener";
          var h = i.split(" ");
          h.forEach(function (t) {
            if (t) {
              if (!a)
                if (o)
                  r._pool = r._pool.filter(function (i) {
                    return i.type !== t || i.listener !== n || i.target !== e;
                  });
                else
                  r._pool.push({ target: e, type: t, listener: n, passive: s });
              var i = E ? { passive: s || false } : false;
              e[l](t, n, i);
            }
          });
        },
      },
    ]);
  })();
  function Z(t, e) {
    if (t.getViewportSizeFn) {
      var i = t.getViewportSizeFn(t, e);
      if (i) return i;
    }
    return { x: document.documentElement.clientWidth, y: window.innerHeight };
  }
  function F(t, e, i, n, s) {
    var o = 0;
    if (e.paddingFn) o = e.paddingFn(i, n, s)[t];
    else if (e.padding) o = e.padding[t];
    else {
      var a = "padding" + t[0].toUpperCase() + t.slice(1);
      if (e[a]) o = e[a];
    }
    return Number(o) || 0;
  }
  function M(t, e, i, n) {
    return {
      x: e.x - F("left", t, e, i, n) - F("right", t, e, i, n),
      y: e.y - F("top", t, e, i, n) - F("bottom", t, e, i, n),
    };
  }
  var R = (function () {
    function t(e) {
      c(this, t);
      this.slide = e;
      this.currZoomLevel = 1;
      this.center = { x: 0, y: 0 };
      this.max = { x: 0, y: 0 };
      this.min = { x: 0, y: 0 };
    }
    return d(t, [
      {
        key: "update",
        value: function t(e) {
          this.currZoomLevel = e;
          if (!this.slide.width) this.reset();
          else {
            this._updateAxis("x");
            this._updateAxis("y");
            this.slide.pswp.dispatch("calcBounds", { slide: this.slide });
          }
        },
      },
      {
        key: "_updateAxis",
        value: function t(e) {
          var i = this.slide.pswp;
          var n =
            this.slide[e === "x" ? "width" : "height"] * this.currZoomLevel;
          var s = e === "x" ? "left" : "top";
          var o = F(
            s,
            i.options,
            i.viewportSize,
            this.slide.data,
            this.slide.index
          );
          var a = this.slide.panAreaSize[e];
          this.center[e] = Math.round((a - n) / 2) + o;
          this.max[e] = n > a ? Math.round(a - n) + o : this.center[e];
          this.min[e] = n > a ? o : this.center[e];
        },
      },
      {
        key: "reset",
        value: function t() {
          this.center.x = 0;
          this.center.y = 0;
          this.max.x = 0;
          this.max.y = 0;
          this.min.x = 0;
          this.min.y = 0;
        },
      },
      {
        key: "correctPan",
        value: function t(e, i) {
          return b(i, this.max[e], this.min[e]);
        },
      },
    ]);
  })();
  var B = 4e3;
  var N = (function () {
    function t(e, i, n, s) {
      c(this, t);
      this.pswp = s;
      this.options = e;
      this.itemData = i;
      this.index = n;
      this.panAreaSize = null;
      this.elementSize = null;
      this.fit = 1;
      this.fill = 1;
      this.vFill = 1;
      this.initial = 1;
      this.secondary = 1;
      this.max = 1;
      this.min = 1;
    }
    return d(t, [
      {
        key: "update",
        value: function t(e, i, n) {
          var s = { x: e, y: i };
          this.elementSize = s;
          this.panAreaSize = n;
          var o = n.x / s.x;
          var a = n.y / s.y;
          this.fit = Math.min(1, o < a ? o : a);
          this.fill = Math.min(1, o > a ? o : a);
          this.vFill = Math.min(1, a);
          this.initial = this._getInitial();
          this.secondary = this._getSecondary();
          this.max = Math.max(this.initial, this.secondary, this._getMax());
          this.min = Math.min(this.fit, this.initial, this.secondary);
          if (this.pswp)
            this.pswp.dispatch("zoomLevelsUpdate", {
              zoomLevels: this,
              slideData: this.itemData,
            });
        },
      },
      {
        key: "_parseZoomLevelOption",
        value: function t(e) {
          var i = e + "ZoomLevel";
          var n = this.options[i];
          if (!n) return;
          if (typeof n === "function") return n(this);
          if (n === "fill") return this.fill;
          if (n === "fit") return this.fit;
          return Number(n);
        },
      },
      {
        key: "_getSecondary",
        value: function t() {
          var e = this._parseZoomLevelOption("secondary");
          if (e) return e;
          e = Math.min(1, this.fit * 3);
          if (this.elementSize && e * this.elementSize.x > B)
            e = B / this.elementSize.x;
          return e;
        },
      },
      {
        key: "_getInitial",
        value: function t() {
          return this._parseZoomLevelOption("initial") || this.fit;
        },
      },
      {
        key: "_getMax",
        value: function t() {
          return this._parseZoomLevelOption("max") || Math.max(1, this.fit * 4);
        },
      },
    ]);
  })();
  var H = (function () {
    function t(e, i, n) {
      c(this, t);
      this.data = e;
      this.index = i;
      this.pswp = n;
      this.isActive = i === n.currIndex;
      this.currentResolution = 0;
      this.panAreaSize = { x: 0, y: 0 };
      this.pan = { x: 0, y: 0 };
      this.isFirstSlide = this.isActive && !n.opener.isOpen;
      this.zoomLevels = new N(n.options, e, i, n);
      this.pswp.dispatch("gettingData", {
        slide: this,
        data: this.data,
        index: i,
      });
      this.content = this.pswp.contentLoader.getContentBySlide(this);
      this.container = m("pswp__zoom-wrap", "div");
      this.holderElement = null;
      this.currZoomLevel = 1;
      this.width = this.content.width;
      this.height = this.content.height;
      this.heavyAppended = false;
      this.bounds = new R(this);
      this.prevDisplayedWidth = -1;
      this.prevDisplayedHeight = -1;
      this.pswp.dispatch("slideInit", { slide: this });
    }
    return d(t, [
      {
        key: "setIsActive",
        value: function t(e) {
          if (e && !this.isActive) this.activate();
          else if (!e && this.isActive) this.deactivate();
        },
      },
      {
        key: "append",
        value: function t(e) {
          this.holderElement = e;
          this.container.style.transformOrigin = "0 0";
          if (!this.data) return;
          this.calculateSize();
          this.load();
          this.updateContentSize();
          this.appendHeavy();
          this.holderElement.appendChild(this.container);
          this.zoomAndPanToInitial();
          this.pswp.dispatch("firstZoomPan", { slide: this });
          this.applyCurrentZoomPan();
          this.pswp.dispatch("afterSetContent", { slide: this });
          if (this.isActive) this.activate();
        },
      },
      {
        key: "load",
        value: function t() {
          this.content.load(false);
          this.pswp.dispatch("slideLoad", { slide: this });
        },
      },
      {
        key: "appendHeavy",
        value: function t() {
          var e = this.pswp;
          var i = true;
          if (
            this.heavyAppended ||
            !e.opener.isOpen ||
            e.mainScroll.isShifted() ||
            (!this.isActive && !i)
          )
            return;
          if (
            this.pswp.dispatch("appendHeavy", { slide: this }).defaultPrevented
          )
            return;
          this.heavyAppended = true;
          this.content.append();
          this.pswp.dispatch("appendHeavyContent", { slide: this });
        },
      },
      {
        key: "activate",
        value: function t() {
          this.isActive = true;
          this.appendHeavy();
          this.content.activate();
          this.pswp.dispatch("slideActivate", { slide: this });
        },
      },
      {
        key: "deactivate",
        value: function t() {
          this.isActive = false;
          this.content.deactivate();
          if (this.currZoomLevel !== this.zoomLevels.initial)
            this.calculateSize();
          this.currentResolution = 0;
          this.zoomAndPanToInitial();
          this.applyCurrentZoomPan();
          this.updateContentSize();
          this.pswp.dispatch("slideDeactivate", { slide: this });
        },
      },
      {
        key: "destroy",
        value: function t() {
          this.content.hasSlide = false;
          this.content.remove();
          this.container.remove();
          this.pswp.dispatch("slideDestroy", { slide: this });
        },
      },
      {
        key: "resize",
        value: function t() {
          if (
            this.currZoomLevel === this.zoomLevels.initial ||
            !this.isActive
          ) {
            this.calculateSize();
            this.currentResolution = 0;
            this.zoomAndPanToInitial();
            this.applyCurrentZoomPan();
            this.updateContentSize();
          } else {
            this.calculateSize();
            this.bounds.update(this.currZoomLevel);
            this.panTo(this.pan.x, this.pan.y);
          }
        },
      },
      {
        key: "updateContentSize",
        value: function t(e) {
          var i = this.currentResolution || this.zoomLevels.initial;
          if (!i) return;
          var n = Math.round(this.width * i) || this.pswp.viewportSize.x;
          var s = Math.round(this.height * i) || this.pswp.viewportSize.y;
          if (!this.sizeChanged(n, s) && !e) return;
          this.content.setDisplayedSize(n, s);
        },
      },
      {
        key: "sizeChanged",
        value: function t(e, i) {
          if (e !== this.prevDisplayedWidth || i !== this.prevDisplayedHeight) {
            this.prevDisplayedWidth = e;
            this.prevDisplayedHeight = i;
            return true;
          }
          return false;
        },
      },
      {
        key: "getPlaceholderElement",
        value: function t() {
          var e;
          return (e = this.content.placeholder) === null || e === void 0
            ? void 0
            : e.element;
        },
      },
      {
        key: "zoomTo",
        value: function t(e, i, n, s) {
          var o = this;
          var a = this.pswp;
          if (!this.isZoomable() || a.mainScroll.isShifted()) return;
          a.dispatch("beforeZoomTo", {
            destZoomLevel: e,
            centerPoint: i,
            transitionDuration: n,
          });
          a.animations.stopAllPan();
          var r = this.currZoomLevel;
          if (!s) e = b(e, this.zoomLevels.min, this.zoomLevels.max);
          this.setZoomLevel(e);
          this.pan.x = this.calculateZoomToPanOffset("x", i, r);
          this.pan.y = this.calculateZoomToPanOffset("y", i, r);
          g(this.pan);
          var l = function t() {
            o._setResolution(e);
            o.applyCurrentZoomPan();
          };
          if (!n) l();
          else
            a.animations.startTransition({
              isPan: true,
              name: "zoomTo",
              target: this.container,
              transform: this.getCurrentTransform(),
              onComplete: l,
              duration: n,
              easing: a.options.easing,
            });
        },
      },
      {
        key: "toggleZoom",
        value: function t(e) {
          this.zoomTo(
            this.currZoomLevel === this.zoomLevels.initial
              ? this.zoomLevels.secondary
              : this.zoomLevels.initial,
            e,
            this.pswp.options.zoomAnimationDuration
          );
        },
      },
      {
        key: "setZoomLevel",
        value: function t(e) {
          this.currZoomLevel = e;
          this.bounds.update(this.currZoomLevel);
        },
      },
      {
        key: "calculateZoomToPanOffset",
        value: function t(e, i, n) {
          var s = this.bounds.max[e] - this.bounds.min[e];
          if (s === 0) return this.bounds.center[e];
          if (!i) i = this.pswp.getViewportCenterPoint();
          if (!n) n = this.zoomLevels.initial;
          var o = this.currZoomLevel / n;
          return this.bounds.correctPan(e, (this.pan[e] - i[e]) * o + i[e]);
        },
      },
      {
        key: "panTo",
        value: function t(e, i) {
          this.pan.x = this.bounds.correctPan("x", e);
          this.pan.y = this.bounds.correctPan("y", i);
          this.applyCurrentZoomPan();
        },
      },
      {
        key: "isPannable",
        value: function t() {
          return (
            Boolean(this.width) && this.currZoomLevel > this.zoomLevels.fit
          );
        },
      },
      {
        key: "isZoomable",
        value: function t() {
          return Boolean(this.width) && this.content.isZoomable();
        },
      },
      {
        key: "applyCurrentZoomPan",
        value: function t() {
          this._applyZoomTransform(this.pan.x, this.pan.y, this.currZoomLevel);
          if (this === this.pswp.currSlide)
            this.pswp.dispatch("zoomPanUpdate", { slide: this });
        },
      },
      {
        key: "zoomAndPanToInitial",
        value: function t() {
          this.currZoomLevel = this.zoomLevels.initial;
          this.bounds.update(this.currZoomLevel);
          y(this.pan, this.bounds.center);
          this.pswp.dispatch("initialZoomPan", { slide: this });
        },
      },
      {
        key: "_applyZoomTransform",
        value: function t(e, i, n) {
          n /= this.currentResolution || this.zoomLevels.initial;
          S(this.container, e, i, n);
        },
      },
      {
        key: "calculateSize",
        value: function t() {
          var e = this.pswp;
          y(
            this.panAreaSize,
            M(e.options, e.viewportSize, this.data, this.index)
          );
          this.zoomLevels.update(this.width, this.height, this.panAreaSize);
          e.dispatch("calcSlideSize", { slide: this });
        },
      },
      {
        key: "getCurrentTransform",
        value: function t() {
          var e =
            this.currZoomLevel /
            (this.currentResolution || this.zoomLevels.initial);
          return x(this.pan.x, this.pan.y, e);
        },
      },
      {
        key: "_setResolution",
        value: function t(e) {
          if (e === this.currentResolution) return;
          this.currentResolution = e;
          this.updateContentSize();
          this.pswp.dispatch("resolutionChanged");
        },
      },
    ]);
  })();
  var W = 0.35;
  var j = 0.6;
  var V = 0.4;
  var q = 0.5;
  function U(t, e) {
    return (t * e) / (1 - e);
  }
  var G = (function () {
    function t(e) {
      c(this, t);
      this.gestures = e;
      this.pswp = e.pswp;
      this.startPan = { x: 0, y: 0 };
    }
    return d(t, [
      {
        key: "start",
        value: function t() {
          if (this.pswp.currSlide) y(this.startPan, this.pswp.currSlide.pan);
          this.pswp.animations.stopAll();
        },
      },
      {
        key: "change",
        value: function t() {
          var e = this.gestures,
            i = e.p1,
            n = e.prevP1,
            s = e.dragAxis;
          var o = this.pswp.currSlide;
          if (
            s === "y" &&
            this.pswp.options.closeOnVerticalDrag &&
            o &&
            o.currZoomLevel <= o.zoomLevels.fit &&
            !this.gestures.isMultitouch
          ) {
            var a = o.pan.y + (i.y - n.y);
            if (
              !this.pswp.dispatch("verticalDrag", { panY: a }).defaultPrevented
            ) {
              this._setPanWithFriction("y", a, j);
              var r = 1 - Math.abs(this._getVerticalDragRatio(o.pan.y));
              this.pswp.applyBgOpacity(r);
              o.applyCurrentZoomPan();
            }
          } else {
            var l = this._panOrMoveMainScroll("x");
            if (!l) {
              this._panOrMoveMainScroll("y");
              if (o) {
                g(o.pan);
                o.applyCurrentZoomPan();
              }
            }
          }
        },
      },
      {
        key: "end",
        value: function t() {
          var e = this.gestures.velocity;
          var i = this.pswp,
            n = i.mainScroll,
            s = i.currSlide;
          var o = 0;
          this.pswp.animations.stopAll();
          if (n.isShifted()) {
            var a = n.x - n.getCurrSlideX();
            var r = a / this.pswp.viewportSize.x;
            if ((e.x < -q && r < 0) || (e.x < 0.1 && r < -0.5)) {
              o = 1;
              e.x = Math.min(e.x, 0);
            } else if ((e.x > q && r > 0) || (e.x > -0.1 && r > 0.5)) {
              o = -1;
              e.x = Math.max(e.x, 0);
            }
            n.moveIndexBy(o, true, e.x);
          }
          if (
            (s && s.currZoomLevel > s.zoomLevels.max) ||
            this.gestures.isMultitouch
          )
            this.gestures.zoomLevels.correctZoomPan(true);
          else {
            this._finishPanGestureForAxis("x");
            this._finishPanGestureForAxis("y");
          }
        },
      },
      {
        key: "_finishPanGestureForAxis",
        value: function t(e) {
          var i = this;
          var n = this.gestures.velocity;
          var s = this.pswp.currSlide;
          if (!s) return;
          var o = s.pan,
            a = s.bounds;
          var r = o[e];
          var l = this.pswp.bgOpacity < 1 && e === "y";
          var h = 0.995;
          var u = r + U(n[e], h);
          if (l) {
            var c = this._getVerticalDragRatio(r);
            var p = this._getVerticalDragRatio(u);
            if ((c < 0 && p < -V) || (c > 0 && p > V)) {
              this.pswp.close();
              return;
            }
          }
          var d = a.correctPan(e, u);
          if (r === d) return;
          var f = d === u ? 1 : 0.82;
          var v = this.pswp.bgOpacity;
          var m = d - r;
          this.pswp.animations.startSpring({
            name: "panGesture" + e,
            isPan: true,
            start: r,
            end: d,
            velocity: n[e],
            dampingRatio: f,
            onUpdate: function t(n) {
              if (l && i.pswp.bgOpacity < 1) {
                var a = 1 - (d - n) / m;
                i.pswp.applyBgOpacity(b(v + (1 - v) * a, 0, 1));
              }
              o[e] = Math.floor(n);
              s.applyCurrentZoomPan();
            },
          });
        },
      },
      {
        key: "_panOrMoveMainScroll",
        value: function t(e) {
          var i = this.gestures,
            n = i.p1,
            s = i.dragAxis,
            o = i.prevP1,
            a = i.isMultitouch;
          var r = this.pswp,
            l = r.currSlide,
            h = r.mainScroll;
          var u = n[e] - o[e];
          var c = h.x + u;
          if (!u || !l) return false;
          if (e === "x" && !l.isPannable() && !a) {
            h.moveTo(c, true);
            return true;
          }
          var p = l.bounds;
          var d = l.pan[e] + u;
          if (
            this.pswp.options.allowPanToNext &&
            s === "x" &&
            e === "x" &&
            !a
          ) {
            var f = h.getCurrSlideX();
            var v = h.x - f;
            var m = u > 0;
            var y = !m;
            if (d > p.min[e] && m) {
              var g = p.min[e] <= this.startPan[e];
              if (g) {
                h.moveTo(c, true);
                return true;
              } else this._setPanWithFriction(e, d);
            } else if (d < p.max[e] && y) {
              var _ = this.startPan[e] <= p.max[e];
              if (_) {
                h.moveTo(c, true);
                return true;
              } else this._setPanWithFriction(e, d);
            } else if (v !== 0) {
              if (v > 0) {
                h.moveTo(Math.max(c, f), true);
                return true;
              } else if (v < 0) {
                h.moveTo(Math.min(c, f), true);
                return true;
              }
            } else this._setPanWithFriction(e, d);
          } else if (e === "y") {
            if (!h.isShifted() && p.min.y !== p.max.y)
              this._setPanWithFriction(e, d);
          } else this._setPanWithFriction(e, d);
          return false;
        },
      },
      {
        key: "_getVerticalDragRatio",
        value: function t(e) {
          var i, n;
          return (
            (e -
              ((i =
                (n = this.pswp.currSlide) === null || n === void 0
                  ? void 0
                  : n.bounds.center.y) !== null && i !== void 0
                ? i
                : 0)) /
            (this.pswp.viewportSize.y / 3)
          );
        },
      },
      {
        key: "_setPanWithFriction",
        value: function t(e, i, n) {
          var s = this.pswp.currSlide;
          if (!s) return;
          var o = s.pan,
            a = s.bounds;
          var r = a.correctPan(e, i);
          if (r !== i || n) {
            var l = Math.round(i - o[e]);
            o[e] += l * (n || W);
          } else o[e] = i;
        },
      },
    ]);
  })();
  var K = 0.05;
  var X = 0.15;
  function Y(t, e, i) {
    t.x = (e.x + i.x) / 2;
    t.y = (e.y + i.y) / 2;
    return t;
  }
  var J = (function () {
    function t(e) {
      c(this, t);
      this.gestures = e;
      this._startPan = { x: 0, y: 0 };
      this._startZoomPoint = { x: 0, y: 0 };
      this._zoomPoint = { x: 0, y: 0 };
      this._wasOverFitZoomLevel = false;
      this._startZoomLevel = 1;
    }
    return d(t, [
      {
        key: "start",
        value: function t() {
          var e = this.gestures.pswp.currSlide;
          if (e) {
            this._startZoomLevel = e.currZoomLevel;
            y(this._startPan, e.pan);
          }
          this.gestures.pswp.animations.stopAllPan();
          this._wasOverFitZoomLevel = false;
        },
      },
      {
        key: "change",
        value: function t() {
          var e = this.gestures,
            i = e.p1,
            n = e.startP1,
            s = e.p2,
            o = e.startP2,
            a = e.pswp;
          var r = a.currSlide;
          if (!r) return;
          var l = r.zoomLevels.min;
          var h = r.zoomLevels.max;
          if (!r.isZoomable() || a.mainScroll.isShifted()) return;
          Y(this._startZoomPoint, n, o);
          Y(this._zoomPoint, i, s);
          var u = (1 / _(n, o)) * _(i, s) * this._startZoomLevel;
          if (u > r.zoomLevels.initial + r.zoomLevels.initial / 15)
            this._wasOverFitZoomLevel = true;
          if (u < l)
            if (
              a.options.pinchToClose &&
              !this._wasOverFitZoomLevel &&
              this._startZoomLevel <= r.zoomLevels.initial
            ) {
              var c = 1 - (l - u) / (l / 1.2);
              if (!a.dispatch("pinchClose", { bgOpacity: c }).defaultPrevented)
                a.applyBgOpacity(c);
            } else u = l - (l - u) * X;
          else if (u > h) u = h + (u - h) * K;
          r.pan.x = this._calculatePanForZoomLevel("x", u);
          r.pan.y = this._calculatePanForZoomLevel("y", u);
          r.setZoomLevel(u);
          r.applyCurrentZoomPan();
        },
      },
      {
        key: "end",
        value: function t() {
          var e = this.gestures.pswp;
          var i = e.currSlide;
          if (
            (!i || i.currZoomLevel < i.zoomLevels.initial) &&
            !this._wasOverFitZoomLevel &&
            e.options.pinchToClose
          )
            e.close();
          else this.correctZoomPan();
        },
      },
      {
        key: "_calculatePanForZoomLevel",
        value: function t(e, i) {
          var n = i / this._startZoomLevel;
          return (
            this._zoomPoint[e] -
            (this._startZoomPoint[e] - this._startPan[e]) * n
          );
        },
      },
      {
        key: "correctZoomPan",
        value: function t(e) {
          var i = this.gestures.pswp;
          var n = i.currSlide;
          if (!(n !== null && n !== void 0 && n.isZoomable())) return;
          if (this._zoomPoint.x === 0) e = true;
          var s = n.currZoomLevel;
          var o;
          var a = true;
          if (s < n.zoomLevels.initial) o = n.zoomLevels.initial;
          else if (s > n.zoomLevels.max) o = n.zoomLevels.max;
          else {
            a = false;
            o = s;
          }
          var r = i.bgOpacity;
          var l = i.bgOpacity < 1;
          var h = y({ x: 0, y: 0 }, n.pan);
          var u = y({ x: 0, y: 0 }, h);
          if (e) {
            this._zoomPoint.x = 0;
            this._zoomPoint.y = 0;
            this._startZoomPoint.x = 0;
            this._startZoomPoint.y = 0;
            this._startZoomLevel = s;
            y(this._startPan, h);
          }
          if (a)
            u = {
              x: this._calculatePanForZoomLevel("x", o),
              y: this._calculatePanForZoomLevel("y", o),
            };
          n.setZoomLevel(o);
          u = {
            x: n.bounds.correctPan("x", u.x),
            y: n.bounds.correctPan("y", u.y),
          };
          n.setZoomLevel(s);
          var c = !w(u, h);
          if (!c && !a && !l) {
            n._setResolution(o);
            n.applyCurrentZoomPan();
            return;
          }
          i.animations.stopAllPan();
          i.animations.startSpring({
            isPan: true,
            start: 0,
            end: 1e3,
            velocity: 0,
            dampingRatio: 1,
            naturalFrequency: 40,
            onUpdate: function t(e) {
              e /= 1e3;
              if (c || a) {
                if (c) {
                  n.pan.x = h.x + (u.x - h.x) * e;
                  n.pan.y = h.y + (u.y - h.y) * e;
                }
                if (a) {
                  var p = s + (o - s) * e;
                  n.setZoomLevel(p);
                }
                n.applyCurrentZoomPan();
              }
              if (l && i.bgOpacity < 1)
                i.applyBgOpacity(b(r + (1 - r) * e, 0, 1));
            },
            onComplete: function t() {
              n._setResolution(o);
              n.applyCurrentZoomPan();
            },
          });
        },
      },
    ]);
  })();
  function Q(t) {
    return !!t.target.closest(".pswp__container");
  }
  var $ = (function () {
    function t(e) {
      c(this, t);
      this.gestures = e;
    }
    return d(t, [
      {
        key: "click",
        value: function t(e, i) {
          var n = i.target.classList;
          var s = n.contains("pswp__img");
          var o = n.contains("pswp__item") || n.contains("pswp__zoom-wrap");
          if (s) this._doClickOrTapAction("imageClick", e, i);
          else if (o) this._doClickOrTapAction("bgClick", e, i);
        },
      },
      {
        key: "tap",
        value: function t(e, i) {
          if (Q(i)) this._doClickOrTapAction("tap", e, i);
        },
      },
      {
        key: "doubleTap",
        value: function t(e, i) {
          if (Q(i)) this._doClickOrTapAction("doubleTap", e, i);
        },
      },
      {
        key: "_doClickOrTapAction",
        value: function t(e, i, n) {
          var s;
          var o = this.gestures.pswp;
          var a = o.currSlide;
          var r = e + "Action";
          var l = o.options[r];
          if (o.dispatch(r, { point: i, originalEvent: n }).defaultPrevented)
            return;
          if (typeof l === "function") {
            l.call(o, i, n);
            return;
          }
          switch (l) {
            case "close":
            case "next":
              o[l]();
              break;
            case "zoom":
              a === null || a === void 0 || a.toggleZoom(i);
              break;
            case "zoom-or-close":
              if (
                a !== null &&
                a !== void 0 &&
                a.isZoomable() &&
                a.zoomLevels.secondary !== a.zoomLevels.initial
              )
                a.toggleZoom(i);
              else if (o.options.clickToCloseNonZoomable) o.close();
              break;
            case "toggle-controls":
              (s = this.gestures.pswp.element) === null ||
                s === void 0 ||
                s.classList.toggle("pswp--ui-visible");
              break;
          }
        },
      },
    ]);
  })();
  var tt = 10;
  var et = 300;
  var it = 25;
  var nt = (function () {
    function t(e) {
      var i = this;
      c(this, t);
      this.pswp = e;
      this.dragAxis = null;
      this.p1 = { x: 0, y: 0 };
      this.p2 = { x: 0, y: 0 };
      this.prevP1 = { x: 0, y: 0 };
      this.prevP2 = { x: 0, y: 0 };
      this.startP1 = { x: 0, y: 0 };
      this.startP2 = { x: 0, y: 0 };
      this.velocity = { x: 0, y: 0 };
      this._lastStartP1 = { x: 0, y: 0 };
      this._intervalP1 = { x: 0, y: 0 };
      this._numActivePoints = 0;
      this._ongoingPointers = [];
      this._touchEventEnabled = "ontouchstart" in window;
      this._pointerEventEnabled = !!window.PointerEvent;
      this.supportsTouch =
        this._touchEventEnabled ||
        (this._pointerEventEnabled && navigator.maxTouchPoints > 1);
      this._numActivePoints = 0;
      this._intervalTime = 0;
      this._velocityCalculated = false;
      this.isMultitouch = false;
      this.isDragging = false;
      this.isZooming = false;
      this.raf = null;
      this._tapTimer = null;
      if (!this.supportsTouch) e.options.allowPanToNext = false;
      this.drag = new G(this);
      this.zoomLevels = new J(this);
      this.tapHandler = new $(this);
      e.on("bindEvents", function () {
        e.events.add(e.scrollWrap, "click", i._onClick.bind(i));
        if (i._pointerEventEnabled)
          i._bindEvents("pointer", "down", "up", "cancel");
        else if (i._touchEventEnabled) {
          i._bindEvents("touch", "start", "end", "cancel");
          if (e.scrollWrap) {
            e.scrollWrap.ontouchmove = function () {};
            e.scrollWrap.ontouchend = function () {};
          }
        } else i._bindEvents("mouse", "down", "up");
      });
    }
    return d(t, [
      {
        key: "_bindEvents",
        value: function t(e, i, n, s) {
          var o = this.pswp;
          var a = o.events;
          var r = s ? e + s : "";
          a.add(o.scrollWrap, e + i, this.onPointerDown.bind(this));
          a.add(window, e + "move", this.onPointerMove.bind(this));
          a.add(window, e + n, this.onPointerUp.bind(this));
          if (r) a.add(o.scrollWrap, r, this.onPointerUp.bind(this));
        },
      },
      {
        key: "onPointerDown",
        value: function t(e) {
          var i = e.type === "mousedown" || e.pointerType === "mouse";
          if (i && e.button > 0) return;
          var n = this.pswp;
          if (!n.opener.isOpen) {
            e.preventDefault();
            return;
          }
          if (n.dispatch("pointerDown", { originalEvent: e }).defaultPrevented)
            return;
          if (i) {
            n.mouseDetected();
            this._preventPointerEventBehaviour(e, "down");
          }
          n.animations.stopAll();
          this._updatePoints(e, "down");
          if (this._numActivePoints === 1) {
            this.dragAxis = null;
            y(this.startP1, this.p1);
          }
          if (this._numActivePoints > 1) {
            this._clearTapTimer();
            this.isMultitouch = true;
          } else this.isMultitouch = false;
        },
      },
      {
        key: "onPointerMove",
        value: function t(e) {
          this._preventPointerEventBehaviour(e, "move");
          if (!this._numActivePoints) return;
          this._updatePoints(e, "move");
          if (
            this.pswp.dispatch("pointerMove", { originalEvent: e })
              .defaultPrevented
          )
            return;
          if (this._numActivePoints === 1 && !this.isDragging) {
            if (!this.dragAxis) this._calculateDragDirection();
            if (this.dragAxis && !this.isDragging) {
              if (this.isZooming) {
                this.isZooming = false;
                this.zoomLevels.end();
              }
              this.isDragging = true;
              this._clearTapTimer();
              this._updateStartPoints();
              this._intervalTime = Date.now();
              this._velocityCalculated = false;
              y(this._intervalP1, this.p1);
              this.velocity.x = 0;
              this.velocity.y = 0;
              this.drag.start();
              this._rafStopLoop();
              this._rafRenderLoop();
            }
          } else if (this._numActivePoints > 1 && !this.isZooming) {
            this._finishDrag();
            this.isZooming = true;
            this._updateStartPoints();
            this.zoomLevels.start();
            this._rafStopLoop();
            this._rafRenderLoop();
          }
        },
      },
      {
        key: "_finishDrag",
        value: function t() {
          if (this.isDragging) {
            this.isDragging = false;
            if (!this._velocityCalculated) this._updateVelocity(true);
            this.drag.end();
            this.dragAxis = null;
          }
        },
      },
      {
        key: "onPointerUp",
        value: function t(e) {
          if (!this._numActivePoints) return;
          this._updatePoints(e, "up");
          if (
            this.pswp.dispatch("pointerUp", { originalEvent: e })
              .defaultPrevented
          )
            return;
          if (this._numActivePoints === 0) {
            this._rafStopLoop();
            if (this.isDragging) this._finishDrag();
            else if (!this.isZooming && !this.isMultitouch) this._finishTap(e);
          }
          if (this._numActivePoints < 2 && this.isZooming) {
            this.isZooming = false;
            this.zoomLevels.end();
            if (this._numActivePoints === 1) {
              this.dragAxis = null;
              this._updateStartPoints();
            }
          }
        },
      },
      {
        key: "_rafRenderLoop",
        value: function t() {
          if (this.isDragging || this.isZooming) {
            this._updateVelocity();
            if (this.isDragging) {
              if (!w(this.p1, this.prevP1)) this.drag.change();
            } else if (!w(this.p1, this.prevP1) || !w(this.p2, this.prevP2))
              this.zoomLevels.change();
            this._updatePrevPoints();
            this.raf = requestAnimationFrame(this._rafRenderLoop.bind(this));
          }
        },
      },
      {
        key: "_updateVelocity",
        value: function t(e) {
          var i = Date.now();
          var n = i - this._intervalTime;
          if (n < 50 && !e) return;
          this.velocity.x = this._getVelocity("x", n);
          this.velocity.y = this._getVelocity("y", n);
          this._intervalTime = i;
          y(this._intervalP1, this.p1);
          this._velocityCalculated = true;
        },
      },
      {
        key: "_finishTap",
        value: function t(e) {
          var i = this;
          var n = this.pswp.mainScroll;
          if (n.isShifted()) {
            n.moveIndexBy(0, true);
            return;
          }
          if (e.type.indexOf("cancel") > 0) return;
          if (e.type === "mouseup" || e.pointerType === "mouse") {
            this.tapHandler.click(this.startP1, e);
            return;
          }
          var s = this.pswp.options.doubleTapAction ? et : 0;
          if (this._tapTimer) {
            this._clearTapTimer();
            if (_(this._lastStartP1, this.startP1) < it)
              this.tapHandler.doubleTap(this.startP1, e);
          } else {
            y(this._lastStartP1, this.startP1);
            this._tapTimer = setTimeout(function () {
              i.tapHandler.tap(i.startP1, e);
              i._clearTapTimer();
            }, s);
          }
        },
      },
      {
        key: "_clearTapTimer",
        value: function t() {
          if (this._tapTimer) {
            clearTimeout(this._tapTimer);
            this._tapTimer = null;
          }
        },
      },
      {
        key: "_getVelocity",
        value: function t(e, i) {
          var n = this.p1[e] - this._intervalP1[e];
          if (Math.abs(n) > 1 && i > 5) return n / i;
          return 0;
        },
      },
      {
        key: "_rafStopLoop",
        value: function t() {
          if (this.raf) {
            cancelAnimationFrame(this.raf);
            this.raf = null;
          }
        },
      },
      {
        key: "_preventPointerEventBehaviour",
        value: function t(e, i) {
          var n = this.pswp.applyFilters("preventPointerEvent", true, e, i);
          if (n) e.preventDefault();
        },
      },
      {
        key: "_updatePoints",
        value: function t(e, i) {
          if (this._pointerEventEnabled) {
            var n = e;
            var s = this._ongoingPointers.findIndex(function (t) {
              return t.id === n.pointerId;
            });
            if (i === "up" && s > -1) this._ongoingPointers.splice(s, 1);
            else if (i === "down" && s === -1)
              this._ongoingPointers.push(
                this._convertEventPosToPoint(n, { x: 0, y: 0 })
              );
            else if (s > -1)
              this._convertEventPosToPoint(n, this._ongoingPointers[s]);
            this._numActivePoints = this._ongoingPointers.length;
            if (this._numActivePoints > 0) y(this.p1, this._ongoingPointers[0]);
            if (this._numActivePoints > 1) y(this.p2, this._ongoingPointers[1]);
          } else {
            var o = e;
            this._numActivePoints = 0;
            if (o.type.indexOf("touch") > -1) {
              if (o.touches && o.touches.length > 0) {
                this._convertEventPosToPoint(o.touches[0], this.p1);
                this._numActivePoints++;
                if (o.touches.length > 1) {
                  this._convertEventPosToPoint(o.touches[1], this.p2);
                  this._numActivePoints++;
                }
              }
            } else {
              this._convertEventPosToPoint(e, this.p1);
              if (i === "up") this._numActivePoints = 0;
              else this._numActivePoints++;
            }
          }
        },
      },
      {
        key: "_updatePrevPoints",
        value: function t() {
          y(this.prevP1, this.p1);
          y(this.prevP2, this.p2);
        },
      },
      {
        key: "_updateStartPoints",
        value: function t() {
          y(this.startP1, this.p1);
          y(this.startP2, this.p2);
          this._updatePrevPoints();
        },
      },
      {
        key: "_calculateDragDirection",
        value: function t() {
          if (this.pswp.mainScroll.isShifted()) this.dragAxis = "x";
          else {
            var e =
              Math.abs(this.p1.x - this.startP1.x) -
              Math.abs(this.p1.y - this.startP1.y);
            if (e !== 0) {
              var i = e > 0 ? "x" : "y";
              if (Math.abs(this.p1[i] - this.startP1[i]) >= tt)
                this.dragAxis = i;
            }
          }
        },
      },
      {
        key: "_convertEventPosToPoint",
        value: function t(e, i) {
          i.x = e.pageX - this.pswp.offset.x;
          i.y = e.pageY - this.pswp.offset.y;
          if ("pointerId" in e) i.id = e.pointerId;
          else if (e.identifier !== void 0) i.id = e.identifier;
          return i;
        },
      },
      {
        key: "_onClick",
        value: function t(e) {
          if (this.pswp.mainScroll.isShifted()) {
            e.preventDefault();
            e.stopPropagation();
          }
        },
      },
    ]);
  })();
  var st = 0.35;
  var ot = (function () {
    function t(e) {
      c(this, t);
      this.pswp = e;
      this.x = 0;
      this.slideWidth = 0;
      this._currPositionIndex = 0;
      this._prevPositionIndex = 0;
      this._containerShiftIndex = -1;
      this.itemHolders = [];
    }
    return d(t, [
      {
        key: "resize",
        value: function t(e) {
          var i = this;
          var n = this.pswp;
          var s = Math.round(
            n.viewportSize.x + n.viewportSize.x * n.options.spacing
          );
          var o = s !== this.slideWidth;
          if (o) {
            this.slideWidth = s;
            this.moveTo(this.getCurrSlideX());
          }
          this.itemHolders.forEach(function (t, n) {
            if (o) S(t.el, (n + i._containerShiftIndex) * i.slideWidth);
            if (e && t.slide) t.slide.resize();
          });
        },
      },
      {
        key: "resetPosition",
        value: function t() {
          this._currPositionIndex = 0;
          this._prevPositionIndex = 0;
          this.slideWidth = 0;
          this._containerShiftIndex = -1;
        },
      },
      {
        key: "appendHolders",
        value: function t() {
          this.itemHolders = [];
          for (var e = 0; e < 3; e++) {
            var i = m("pswp__item", "div", this.pswp.container);
            i.setAttribute("role", "group");
            i.setAttribute("aria-roledescription", "slide");
            i.setAttribute("aria-hidden", "true");
            i.style.display = e === 1 ? "block" : "none";
            this.itemHolders.push({ el: i });
          }
        },
      },
      {
        key: "canBeSwiped",
        value: function t() {
          return this.pswp.getNumItems() > 1;
        },
      },
      {
        key: "moveIndexBy",
        value: function t(e, i, n) {
          var s = this;
          var o = this.pswp;
          var a = o.potentialIndex + e;
          var r = o.getNumItems();
          if (o.canLoop()) {
            a = o.getLoopedIndex(a);
            var l = (e + r) % r;
            if (l <= r / 2) e = l;
            else e = l - r;
          } else {
            if (a < 0) a = 0;
            else if (a >= r) a = r - 1;
            e = a - o.potentialIndex;
          }
          o.potentialIndex = a;
          this._currPositionIndex -= e;
          o.animations.stopMainScroll();
          var h = this.getCurrSlideX();
          if (!i) {
            this.moveTo(h);
            this.updateCurrItem();
          } else {
            o.animations.startSpring({
              isMainScroll: true,
              start: this.x,
              end: h,
              velocity: n || 0,
              naturalFrequency: 30,
              dampingRatio: 1,
              onUpdate: function t(e) {
                s.moveTo(e);
              },
              onComplete: function t() {
                s.updateCurrItem();
                o.appendHeavy();
              },
            });
            var u = o.potentialIndex - o.currIndex;
            if (o.canLoop()) {
              var c = (u + r) % r;
              if (c <= r / 2) u = c;
              else u = c - r;
            }
            if (Math.abs(u) > 1) this.updateCurrItem();
          }
          return Boolean(e);
        },
      },
      {
        key: "getCurrSlideX",
        value: function t() {
          return this.slideWidth * this._currPositionIndex;
        },
      },
      {
        key: "isShifted",
        value: function t() {
          return this.x !== this.getCurrSlideX();
        },
      },
      {
        key: "updateCurrItem",
        value: function t() {
          var e;
          var i = this.pswp;
          var n = this._prevPositionIndex - this._currPositionIndex;
          if (!n) return;
          this._prevPositionIndex = this._currPositionIndex;
          i.currIndex = i.potentialIndex;
          var s = Math.abs(n);
          var o;
          if (s >= 3) {
            this._containerShiftIndex += n + (n > 0 ? -3 : 3);
            s = 3;
            this.itemHolders.forEach(function (t) {
              var e;
              (e = t.slide) === null || e === void 0 || e.destroy();
              t.slide = void 0;
            });
          }
          for (var a = 0; a < s; a++)
            if (n > 0) {
              o = this.itemHolders.shift();
              if (o) {
                this.itemHolders[2] = o;
                this._containerShiftIndex++;
                S(o.el, (this._containerShiftIndex + 2) * this.slideWidth);
                i.setContent(o, i.currIndex - s + a + 2);
              }
            } else {
              o = this.itemHolders.pop();
              if (o) {
                this.itemHolders.unshift(o);
                this._containerShiftIndex--;
                S(o.el, this._containerShiftIndex * this.slideWidth);
                i.setContent(o, i.currIndex + s - a - 2);
              }
            }
          if (Math.abs(this._containerShiftIndex) > 50 && !this.isShifted()) {
            this.resetPosition();
            this.resize();
          }
          i.animations.stopAllPan();
          this.itemHolders.forEach(function (t, e) {
            if (t.slide) t.slide.setIsActive(e === 1);
          });
          i.currSlide =
            (e = this.itemHolders[1]) === null || e === void 0
              ? void 0
              : e.slide;
          i.contentLoader.updateLazy(n);
          if (i.currSlide) i.currSlide.applyCurrentZoomPan();
          i.dispatch("change");
        },
      },
      {
        key: "moveTo",
        value: function t(e, i) {
          if (!this.pswp.canLoop() && i) {
            var n =
              (this.slideWidth * this._currPositionIndex - e) / this.slideWidth;
            n += this.pswp.currIndex;
            var s = Math.round(e - this.x);
            if ((n < 0 && s > 0) || (n >= this.pswp.getNumItems() - 1 && s < 0))
              e = this.x + s * st;
          }
          this.x = e;
          if (this.pswp.container) S(this.pswp.container, e);
          this.pswp.dispatch("moveMainScroll", {
            x: e,
            dragging: i !== null && i !== void 0 ? i : false,
          });
        },
      },
    ]);
  })();
  var at = {
    Escape: 27,
    z: 90,
    ArrowLeft: 37,
    ArrowUp: 38,
    ArrowRight: 39,
    ArrowDown: 40,
    Tab: 9,
  };
  var rt = function t(e, i) {
    return i ? e : at[e];
  };
  var lt = (function () {
    function t(e) {
      var i = this;
      c(this, t);
      this.pswp = e;
      this._wasFocused = false;
      e.on("bindEvents", function () {
        if (e.options.trapFocus) {
          if (!e.options.initialPointerPos) i._focusRoot();
          e.events.add(document, "focusin", i._onFocusIn.bind(i));
        }
        e.events.add(document, "keydown", i._onKeyDown.bind(i));
      });
      var n = document.activeElement;
      e.on("destroy", function () {
        if (e.options.returnFocus && n && i._wasFocused) n.focus();
      });
    }
    return d(t, [
      {
        key: "_focusRoot",
        value: function t() {
          if (!this._wasFocused && this.pswp.element) {
            this.pswp.element.focus();
            this._wasFocused = true;
          }
        },
      },
      {
        key: "_onKeyDown",
        value: function t(e) {
          var i = this.pswp;
          if (i.dispatch("keydown", { originalEvent: e }).defaultPrevented)
            return;
          if (A(e)) return;
          var n;
          var s;
          var o = false;
          var a = "key" in e;
          switch (a ? e.key : e.keyCode) {
            case rt("Escape", a):
              if (i.options.escKey) n = "close";
              break;
            case rt("z", a):
              n = "toggleZoom";
              break;
            case rt("ArrowLeft", a):
              s = "x";
              break;
            case rt("ArrowUp", a):
              s = "y";
              break;
            case rt("ArrowRight", a):
              s = "x";
              o = true;
              break;
            case rt("ArrowDown", a):
              o = true;
              s = "y";
              break;
            case rt("Tab", a):
              this._focusRoot();
              break;
          }
          if (s) {
            e.preventDefault();
            var r = i.currSlide;
            if (i.options.arrowKeys && s === "x" && i.getNumItems() > 1)
              n = o ? "next" : "prev";
            else if (r && r.currZoomLevel > r.zoomLevels.fit) {
              r.pan[s] += o ? -80 : 80;
              r.panTo(r.pan.x, r.pan.y);
            }
          }
          if (n) {
            e.preventDefault();
            i[n]();
          }
        },
      },
      {
        key: "_onFocusIn",
        value: function t(e) {
          var i = this.pswp.template;
          if (
            i &&
            document !== e.target &&
            i !== e.target &&
            !i.contains(e.target)
          )
            i.focus();
        },
      },
    ]);
  })();
  var ht = "cubic-bezier(.4,0,.22,1)";
  var ut = (function () {
    function t(e) {
      var i = this;
      c(this, t);
      var n;
      this.props = e;
      var s = e.target,
        o = e.onComplete,
        a = e.transform,
        r = e.onFinish,
        l = r === void 0 ? function () {} : r,
        h = e.duration,
        u = h === void 0 ? 333 : h,
        p = e.easing,
        d = p === void 0 ? ht : p;
      this.onFinish = l;
      var f = a ? "transform" : "opacity";
      var v = (n = e[f]) !== null && n !== void 0 ? n : "";
      this._target = s;
      this._onComplete = o;
      this._finished = false;
      this._onTransitionEnd = this._onTransitionEnd.bind(this);
      this._helperTimeout = setTimeout(function () {
        k(s, f, u, d);
        i._helperTimeout = setTimeout(function () {
          s.addEventListener("transitionend", i._onTransitionEnd, false);
          s.addEventListener("transitioncancel", i._onTransitionEnd, false);
          i._helperTimeout = setTimeout(function () {
            i._finalizeAnimation();
          }, u + 500);
          s.style[f] = v;
        }, 30);
      }, 0);
    }
    return d(t, [
      {
        key: "_onTransitionEnd",
        value: function t(e) {
          if (e.target === this._target) this._finalizeAnimation();
        },
      },
      {
        key: "_finalizeAnimation",
        value: function t() {
          if (!this._finished) {
            this._finished = true;
            this.onFinish();
            if (this._onComplete) this._onComplete();
          }
        },
      },
      {
        key: "destroy",
        value: function t() {
          if (this._helperTimeout) clearTimeout(this._helperTimeout);
          C(this._target);
          this._target.removeEventListener(
            "transitionend",
            this._onTransitionEnd,
            false
          );
          this._target.removeEventListener(
            "transitioncancel",
            this._onTransitionEnd,
            false
          );
          if (!this._finished) this._finalizeAnimation();
        },
      },
    ]);
  })();
  var ct = 12;
  var pt = 0.75;
  var dt = (function () {
    function t(e, i, n) {
      c(this, t);
      this.velocity = e * 1e3;
      this._dampingRatio = i || pt;
      this._naturalFrequency = n || ct;
      this._dampedFrequency = this._naturalFrequency;
      if (this._dampingRatio < 1)
        this._dampedFrequency *= Math.sqrt(
          1 - this._dampingRatio * this._dampingRatio
        );
    }
    return d(t, [
      {
        key: "easeFrame",
        value: function t(e, i) {
          var n = 0;
          var s;
          i /= 1e3;
          var o = Math.pow(
            Math.E,
            -this._dampingRatio * this._naturalFrequency * i
          );
          if (this._dampingRatio === 1) {
            s = this.velocity + this._naturalFrequency * e;
            n = (e + s * i) * o;
            this.velocity = n * -this._naturalFrequency + s * o;
          } else if (this._dampingRatio < 1) {
            s =
              (1 / this._dampedFrequency) *
              (this._dampingRatio * this._naturalFrequency * e + this.velocity);
            var a = Math.cos(this._dampedFrequency * i);
            var r = Math.sin(this._dampedFrequency * i);
            n = o * (e * a + s * r);
            this.velocity =
              n * -this._naturalFrequency * this._dampingRatio +
              o *
                (-this._dampedFrequency * e * r +
                  this._dampedFrequency * s * a);
          }
          return n;
        },
      },
    ]);
  })();
  var ft = (function () {
    function t(e) {
      var i = this;
      c(this, t);
      this.props = e;
      this._raf = 0;
      var n = e.start,
        s = e.end,
        o = e.velocity,
        a = e.onUpdate,
        r = e.onComplete,
        l = e.onFinish,
        h = l === void 0 ? function () {} : l,
        u = e.dampingRatio,
        p = e.naturalFrequency;
      this.onFinish = h;
      var d = new dt(o, u, p);
      var f = Date.now();
      var v = n - s;
      var m = function t() {
        if (i._raf) {
          v = d.easeFrame(v, Date.now() - f);
          if (Math.abs(v) < 1 && Math.abs(d.velocity) < 50) {
            a(s);
            if (r) r();
            i.onFinish();
          } else {
            f = Date.now();
            a(v + s);
            i._raf = requestAnimationFrame(m);
          }
        }
      };
      this._raf = requestAnimationFrame(m);
    }
    return d(t, [
      {
        key: "destroy",
        value: function t() {
          if (this._raf >= 0) cancelAnimationFrame(this._raf);
          this._raf = 0;
        },
      },
    ]);
  })();
  var vt = (function () {
    function t() {
      c(this, t);
      this.activeAnimations = [];
    }
    return d(t, [
      {
        key: "startSpring",
        value: function t(e) {
          this._start(e, true);
        },
      },
      {
        key: "startTransition",
        value: function t(e) {
          this._start(e);
        },
      },
      {
        key: "_start",
        value: function t(e, i) {
          var n = this;
          var s = i ? new ft(e) : new ut(e);
          this.activeAnimations.push(s);
          s.onFinish = function () {
            return n.stop(s);
          };
          return s;
        },
      },
      {
        key: "stop",
        value: function t(e) {
          e.destroy();
          var i = this.activeAnimations.indexOf(e);
          if (i > -1) this.activeAnimations.splice(i, 1);
        },
      },
      {
        key: "stopAll",
        value: function t() {
          this.activeAnimations.forEach(function (t) {
            t.destroy();
          });
          this.activeAnimations = [];
        },
      },
      {
        key: "stopAllPan",
        value: function t() {
          this.activeAnimations = this.activeAnimations.filter(function (t) {
            if (t.props.isPan) {
              t.destroy();
              return false;
            }
            return true;
          });
        },
      },
      {
        key: "stopMainScroll",
        value: function t() {
          this.activeAnimations = this.activeAnimations.filter(function (t) {
            if (t.props.isMainScroll) {
              t.destroy();
              return false;
            }
            return true;
          });
        },
      },
      {
        key: "isPanRunning",
        value: function t() {
          return this.activeAnimations.some(function (t) {
            return t.props.isPan;
          });
        },
      },
    ]);
  })();
  var mt = (function () {
    function t(e) {
      c(this, t);
      this.pswp = e;
      e.events.add(e.element, "wheel", this._onWheel.bind(this));
    }
    return d(t, [
      {
        key: "_onWheel",
        value: function t(e) {
          e.preventDefault();
          var i = this.pswp.currSlide;
          var n = e.deltaX,
            s = e.deltaY;
          if (!i) return;
          if (
            this.pswp.dispatch("wheel", { originalEvent: e }).defaultPrevented
          )
            return;
          if (e.ctrlKey || this.pswp.options.wheelToZoom) {
            if (i.isZoomable()) {
              var o = -s;
              if (e.deltaMode === 1) o *= 0.05;
              else o *= e.deltaMode ? 1 : 0.002;
              o = Math.pow(2, o);
              var a = i.currZoomLevel * o;
              i.zoomTo(a, { x: e.clientX, y: e.clientY });
            }
          } else if (i.isPannable()) {
            if (e.deltaMode === 1) {
              n *= 18;
              s *= 18;
            }
            i.panTo(i.pan.x - n, i.pan.y - s);
          }
        },
      },
    ]);
  })();
  function yt(t) {
    if (typeof t === "string") return t;
    if (!t || !t.isCustomSVG) return "";
    var e = t;
    var i =
      '<svg aria-hidden="true" class="pswp__icn" viewBox="0 0 %d %d" width="%d" height="%d">';
    i = i.split("%d").join(e.size || 32);
    if (e.outlineID)
      i += '<use class="pswp__icn-shadow" xlink:href="#' + e.outlineID + '"/>';
    i += e.inner;
    i += "</svg>";
    return i;
  }
  var gt = d(function t(e, i) {
    c(this, t);
    var n;
    var s = i.name || i.className;
    var o = i.html;
    if (e.options[s] === false) return;
    if (typeof e.options[s + "SVG"] === "string") o = e.options[s + "SVG"];
    e.dispatch("uiElementCreate", { data: i });
    var a = "";
    if (i.isButton) {
      a += "pswp__button ";
      a += i.className || "pswp__button--".concat(i.name);
    } else a += i.className || "pswp__".concat(i.name);
    var r = i.isButton ? i.tagName || "button" : i.tagName || "div";
    r = r.toLowerCase();
    var l = m(a, r);
    if (i.isButton) {
      if (r === "button") l.type = "button";
      var h = i.title;
      var u = i.ariaLabel;
      if (typeof e.options[s + "Title"] === "string")
        h = e.options[s + "Title"];
      if (h) l.title = h;
      var p = u || h;
      if (p) l.setAttribute("aria-label", p);
    }
    l.innerHTML = yt(o);
    if (i.onInit) i.onInit(l, e);
    if (i.onClick)
      l.onclick = function (t) {
        if (typeof i.onClick === "string") e[i.onClick]();
        else if (typeof i.onClick === "function") i.onClick(t, l, e);
      };
    var d = i.appendTo || "bar";
    var f = e.element;
    if (d === "bar") {
      if (!e.topBar)
        e.topBar = m("pswp__top-bar pswp__hide-on-close", "div", e.scrollWrap);
      f = e.topBar;
    } else {
      l.classList.add("pswp__hide-on-close");
      if (d === "wrapper") f = e.scrollWrap;
    }
    (n = f) === null ||
      n === void 0 ||
      n.appendChild(e.applyFilters("uiElement", l, i));
  });
  function _t(t, e, i) {
    t.classList.add("pswp__button--arrow");
    t.setAttribute("aria-controls", "pswp__items");
    e.on("change", function () {
      if (!e.options.loop)
        if (i) t.disabled = !(e.currIndex < e.getNumItems() - 1);
        else t.disabled = !(e.currIndex > 0);
    });
  }
  var wt = {
    name: "arrowPrev",
    className: "pswp__button--arrow--prev",
    title: "Previous",
    order: 10,
    isButton: true,
    appendTo: "wrapper",
    html: {
      isCustomSVG: true,
      size: 60,
      inner:
        '<path d="M29 43l-3 3-16-16 16-16 3 3-13 13 13 13z" id="pswp__icn-arrow"/>',
      outlineID: "pswp__icn-arrow",
    },
    onClick: "prev",
    onInit: _t,
  };
  var bt = {
    name: "arrowNext",
    className: "pswp__button--arrow--next",
    title: "Next",
    order: 11,
    isButton: true,
    appendTo: "wrapper",
    html: {
      isCustomSVG: true,
      size: 60,
      inner: '<use xlink:href="#pswp__icn-arrow"/>',
      outlineID: "pswp__icn-arrow",
    },
    onClick: "next",
    onInit: function t(e, i) {
      _t(e, i, true);
    },
  };
  var xt = {
    name: "close",
    title: "Close",
    order: 20,
    isButton: true,
    html: {
      isCustomSVG: true,
      inner:
        '<path d="M24 10l-2-2-6 6-6-6-2 2 6 6-6 6 2 2 6-6 6 6 2-2-6-6z" id="pswp__icn-close"/>',
      outlineID: "pswp__icn-close",
    },
    onClick: "close",
  };
  var St = {
    name: "zoom",
    title: "Zoom",
    order: 10,
    isButton: true,
    html: {
      isCustomSVG: true,
      inner:
        '<path d="M17.426 19.926a6 6 0 1 1 1.5-1.5L23 22.5 21.5 24l-4.074-4.074z" id="pswp__icn-zoom"/>' +
        '<path fill="currentColor" class="pswp__zoom-icn-bar-h" d="M11 16v-2h6v2z"/>' +
        '<path fill="currentColor" class="pswp__zoom-icn-bar-v" d="M13 12h2v6h-2z"/>',
      outlineID: "pswp__icn-zoom",
    },
    onClick: "toggleZoom",
  };
  var Pt = {
    name: "preloader",
    appendTo: "bar",
    order: 7,
    html: {
      isCustomSVG: true,
      inner:
        '<path fill-rule="evenodd" clip-rule="evenodd" d="M21.2 16a5.2 5.2 0 1 1-5.2-5.2V8a8 8 0 1 0 8 8h-2.8Z" id="pswp__icn-loading"/>',
      outlineID: "pswp__icn-loading",
    },
    onInit: function t(e, i) {
      var n;
      var s = null;
      var o = function t(i, n) {
        e.classList.toggle("pswp__preloader--" + i, n);
      };
      var a = function t(e) {
        if (n !== e) {
          n = e;
          o("active", e);
        }
      };
      var r = function t() {
        var e;
        if (
          !((e = i.currSlide) !== null && e !== void 0 && e.content.isLoading())
        ) {
          a(false);
          if (s) {
            clearTimeout(s);
            s = null;
          }
          return;
        }
        if (!s)
          s = setTimeout(function () {
            var t;
            a(
              Boolean(
                (t = i.currSlide) === null || t === void 0
                  ? void 0
                  : t.content.isLoading()
              )
            );
            s = null;
          }, i.options.preloaderDelay);
      };
      i.on("change", r);
      i.on("loadComplete", function (t) {
        if (i.currSlide === t.slide) r();
      });
      if (i.ui) i.ui.updatePreloaderVisibility = r;
    },
  };
  var kt = {
    name: "counter",
    order: 5,
    onInit: function t(e, i) {
      i.on("change", function () {
        e.innerText =
          i.currIndex + 1 + i.options.indexIndicatorSep + i.getNumItems();
      });
    },
  };
  function It(t, e) {
    t.classList.toggle("pswp--zoomed-in", e);
  }
  var Ct = (function () {
    function t(e) {
      c(this, t);
      this.pswp = e;
      this.isRegistered = false;
      this.uiElementsData = [];
      this.items = [];
      this.updatePreloaderVisibility = function () {};
      this._lastUpdatedZoomLevel = void 0;
    }
    return d(t, [
      {
        key: "init",
        value: function t() {
          var e = this;
          var i = this.pswp;
          this.isRegistered = false;
          this.uiElementsData = [xt, wt, bt, St, Pt, kt];
          i.dispatch("uiRegister");
          this.uiElementsData.sort(function (t, e) {
            return (t.order || 0) - (e.order || 0);
          });
          this.items = [];
          this.isRegistered = true;
          this.uiElementsData.forEach(function (t) {
            e.registerElement(t);
          });
          i.on("change", function () {
            var t;
            (t = i.element) === null ||
              t === void 0 ||
              t.classList.toggle("pswp--one-slide", i.getNumItems() === 1);
          });
          i.on("zoomPanUpdate", function () {
            return e._onZoomPanUpdate();
          });
        },
      },
      {
        key: "registerElement",
        value: function t(e) {
          if (this.isRegistered) this.items.push(new gt(this.pswp, e));
          else this.uiElementsData.push(e);
        },
      },
      {
        key: "_onZoomPanUpdate",
        value: function t() {
          var e = this.pswp,
            i = e.template,
            n = e.currSlide,
            s = e.options;
          if (this.pswp.opener.isClosing || !i || !n) return;
          var o = n.currZoomLevel;
          if (!this.pswp.opener.isOpen) o = n.zoomLevels.initial;
          if (o === this._lastUpdatedZoomLevel) return;
          this._lastUpdatedZoomLevel = o;
          var a = n.zoomLevels.initial - n.zoomLevels.secondary;
          if (Math.abs(a) < 0.01 || !n.isZoomable()) {
            It(i, false);
            i.classList.remove("pswp--zoom-allowed");
            return;
          }
          i.classList.add("pswp--zoom-allowed");
          var r =
            o === n.zoomLevels.initial
              ? n.zoomLevels.secondary
              : n.zoomLevels.initial;
          It(i, r <= o);
          if (
            s.imageClickAction === "zoom" ||
            s.imageClickAction === "zoom-or-close"
          )
            i.classList.add("pswp--click-to-zoom");
        },
      },
    ]);
  })();
  function Lt(t) {
    var e = t.getBoundingClientRect();
    return { x: e.left, y: e.top, w: e.width };
  }
  function zt(t, e, i) {
    var n = t.getBoundingClientRect();
    var s = n.width / e;
    var o = n.height / i;
    var a = s > o ? s : o;
    var r = (n.width - e * a) / 2;
    var l = (n.height - i * a) / 2;
    var h = { x: n.left + r, y: n.top + l, w: e * a };
    h.innerRect = { w: n.width, h: n.height, x: r, y: l };
    return h;
  }
  function At(t, e, i) {
    var n = i.dispatch("thumbBounds", { index: t, itemData: e, instance: i });
    if (n.thumbBounds) return n.thumbBounds;
    var s = e.element;
    var o;
    var a;
    if (s && i.options.thumbSelector !== false) {
      var r = i.options.thumbSelector || "img";
      a = s.matches(r) ? s : s.querySelector(r);
    }
    a = i.applyFilters("thumbEl", a, e, t);
    if (a)
      if (!e.thumbCropped) o = Lt(a);
      else o = zt(a, e.width || e.w || 0, e.height || e.h || 0);
    return i.applyFilters("thumbBounds", o, e, t);
  }
  var Ot = (function () {
    function t(e, i) {
      c(this, t);
      this.type = e;
      this.defaultPrevented = false;
      if (i) Object.assign(this, i);
    }
    return d(t, [
      {
        key: "preventDefault",
        value: function t() {
          this.defaultPrevented = true;
        },
      },
    ]);
  })();
  var Tt = (function () {
    function t() {
      c(this, t);
      this._listeners = {};
      this._filters = {};
      this.pswp = void 0;
      this.options = void 0;
    }
    return d(t, [
      {
        key: "addFilter",
        value: function t(e, i) {
          var n =
            arguments.length > 2 && arguments[2] !== void 0
              ? arguments[2]
              : 100;
          var s, o, a;
          if (!this._filters[e]) this._filters[e] = [];
          (s = this._filters[e]) === null ||
            s === void 0 ||
            s.push({ fn: i, priority: n });
          (o = this._filters[e]) === null ||
            o === void 0 ||
            o.sort(function (t, e) {
              return t.priority - e.priority;
            });
          (a = this.pswp) === null || a === void 0 || a.addFilter(e, i, n);
        },
      },
      {
        key: "removeFilter",
        value: function t(e, i) {
          if (this._filters[e])
            this._filters[e] = this._filters[e].filter(function (t) {
              return t.fn !== i;
            });
          if (this.pswp) this.pswp.removeFilter(e, i);
        },
      },
      {
        key: "applyFilters",
        value: function t(e) {
          var i = this;
          for (
            var n = arguments.length, s = new Array(n > 1 ? n - 1 : 0), o = 1;
            o < n;
            o++
          )
            s[o - 1] = arguments[o];
          var a;
          (a = this._filters[e]) === null ||
            a === void 0 ||
            a.forEach(function (t) {
              s[0] = t.fn.apply(i, s);
            });
          return s[0];
        },
      },
      {
        key: "on",
        value: function t(e, i) {
          var n, s;
          if (!this._listeners[e]) this._listeners[e] = [];
          (n = this._listeners[e]) === null || n === void 0 || n.push(i);
          (s = this.pswp) === null || s === void 0 || s.on(e, i);
        },
      },
      {
        key: "off",
        value: function t(e, i) {
          var n;
          if (this._listeners[e])
            this._listeners[e] = this._listeners[e].filter(function (t) {
              return i !== t;
            });
          (n = this.pswp) === null || n === void 0 || n.off(e, i);
        },
      },
      {
        key: "dispatch",
        value: function t(e, i) {
          var n = this;
          var s;
          if (this.pswp) return this.pswp.dispatch(e, i);
          var o = new Ot(e, i);
          (s = this._listeners[e]) === null ||
            s === void 0 ||
            s.forEach(function (t) {
              t.call(n, o);
            });
          return o;
        },
      },
    ]);
  })();
  var Et = (function () {
    function t(e, i) {
      c(this, t);
      this.element = m(
        "pswp__img pswp__img--placeholder",
        e ? "img" : "div",
        i
      );
      if (e) {
        var n = this.element;
        n.decoding = "async";
        n.alt = "";
        n.src = e;
        n.setAttribute("role", "presentation");
      }
      this.element.setAttribute("aria-hidden", "true");
    }
    return d(t, [
      {
        key: "setDisplayedSize",
        value: function t(e, i) {
          if (!this.element) return;
          if (this.element.tagName === "IMG") {
            I(this.element, 250, "auto");
            this.element.style.transformOrigin = "0 0";
            this.element.style.transform = x(0, 0, e / 250);
          } else I(this.element, e, i);
        },
      },
      {
        key: "destroy",
        value: function t() {
          var e;
          if ((e = this.element) !== null && e !== void 0 && e.parentNode)
            this.element.remove();
          this.element = null;
        },
      },
    ]);
  })();
  var Dt = (function () {
    function t(e, i, n) {
      c(this, t);
      this.instance = i;
      this.data = e;
      this.index = n;
      this.element = void 0;
      this.placeholder = void 0;
      this.slide = void 0;
      this.displayedImageWidth = 0;
      this.displayedImageHeight = 0;
      this.width = Number(this.data.w) || Number(this.data.width) || 0;
      this.height = Number(this.data.h) || Number(this.data.height) || 0;
      this.isAttached = false;
      this.hasSlide = false;
      this.isDecoding = false;
      this.state = z.IDLE;
      if (this.data.type) this.type = this.data.type;
      else if (this.data.src) this.type = "image";
      else this.type = "html";
      this.instance.dispatch("contentInit", { content: this });
    }
    return d(t, [
      {
        key: "removePlaceholder",
        value: function t() {
          var e = this;
          if (this.placeholder && !this.keepPlaceholder())
            setTimeout(function () {
              if (e.placeholder) {
                e.placeholder.destroy();
                e.placeholder = void 0;
              }
            }, 1e3);
        },
      },
      {
        key: "load",
        value: function t(e, i) {
          if (this.slide && this.usePlaceholder())
            if (!this.placeholder) {
              var n = this.instance.applyFilters(
                "placeholderSrc",
                this.data.msrc && this.slide.isFirstSlide
                  ? this.data.msrc
                  : false,
                this
              );
              this.placeholder = new Et(n, this.slide.container);
            } else {
              var s = this.placeholder.element;
              if (s && !s.parentElement) this.slide.container.prepend(s);
            }
          if (this.element && !i) return;
          if (
            this.instance.dispatch("contentLoad", { content: this, isLazy: e })
              .defaultPrevented
          )
            return;
          if (this.isImageContent()) {
            this.element = m("pswp__img", "img");
            if (this.displayedImageWidth) this.loadImage(e);
          } else {
            this.element = m("pswp__content", "div");
            this.element.innerHTML = this.data.html || "";
          }
          if (i && this.slide) this.slide.updateContentSize(true);
        },
      },
      {
        key: "loadImage",
        value: function t(e) {
          var i = this;
          var n, s;
          if (
            !this.isImageContent() ||
            !this.element ||
            this.instance.dispatch("contentLoadImage", {
              content: this,
              isLazy: e,
            }).defaultPrevented
          )
            return;
          var o = this.element;
          this.updateSrcsetSizes();
          if (this.data.srcset) o.srcset = this.data.srcset;
          o.src = (n = this.data.src) !== null && n !== void 0 ? n : "";
          o.alt = (s = this.data.alt) !== null && s !== void 0 ? s : "";
          this.state = z.LOADING;
          if (o.complete) this.onLoaded();
          else {
            o.onload = function () {
              i.onLoaded();
            };
            o.onerror = function () {
              i.onError();
            };
          }
        },
      },
      {
        key: "setSlide",
        value: function t(e) {
          this.slide = e;
          this.hasSlide = true;
          this.instance = e.pswp;
        },
      },
      {
        key: "onLoaded",
        value: function t() {
          this.state = z.LOADED;
          if (this.slide && this.element) {
            this.instance.dispatch("loadComplete", {
              slide: this.slide,
              content: this,
            });
            if (
              this.slide.isActive &&
              this.slide.heavyAppended &&
              !this.element.parentNode
            ) {
              this.append();
              this.slide.updateContentSize(true);
            }
            if (this.state === z.LOADED || this.state === z.ERROR)
              this.removePlaceholder();
          }
        },
      },
      {
        key: "onError",
        value: function t() {
          this.state = z.ERROR;
          if (this.slide) {
            this.displayError();
            this.instance.dispatch("loadComplete", {
              slide: this.slide,
              isError: true,
              content: this,
            });
            this.instance.dispatch("loadError", {
              slide: this.slide,
              content: this,
            });
          }
        },
      },
      {
        key: "isLoading",
        value: function t() {
          return this.instance.applyFilters(
            "isContentLoading",
            this.state === z.LOADING,
            this
          );
        },
      },
      {
        key: "isError",
        value: function t() {
          return this.state === z.ERROR;
        },
      },
      {
        key: "isImageContent",
        value: function t() {
          return this.type === "image";
        },
      },
      {
        key: "setDisplayedSize",
        value: function t(e, i) {
          if (!this.element) return;
          if (this.placeholder) this.placeholder.setDisplayedSize(e, i);
          if (
            this.instance.dispatch("contentResize", {
              content: this,
              width: e,
              height: i,
            }).defaultPrevented
          )
            return;
          I(this.element, e, i);
          if (this.isImageContent() && !this.isError()) {
            var n = !this.displayedImageWidth && e;
            this.displayedImageWidth = e;
            this.displayedImageHeight = i;
            if (n) this.loadImage(false);
            else this.updateSrcsetSizes();
            if (this.slide)
              this.instance.dispatch("imageSizeChange", {
                slide: this.slide,
                width: e,
                height: i,
                content: this,
              });
          }
        },
      },
      {
        key: "isZoomable",
        value: function t() {
          return this.instance.applyFilters(
            "isContentZoomable",
            this.isImageContent() && this.state !== z.ERROR,
            this
          );
        },
      },
      {
        key: "updateSrcsetSizes",
        value: function t() {
          if (!this.isImageContent() || !this.element || !this.data.srcset)
            return;
          var e = this.element;
          var i = this.instance.applyFilters(
            "srcsetSizesWidth",
            this.displayedImageWidth,
            this
          );
          if (
            !e.dataset.largestUsedSize ||
            i > parseInt(e.dataset.largestUsedSize, 10)
          ) {
            e.sizes = i + "px";
            e.dataset.largestUsedSize = String(i);
          }
        },
      },
      {
        key: "usePlaceholder",
        value: function t() {
          return this.instance.applyFilters(
            "useContentPlaceholder",
            this.isImageContent(),
            this
          );
        },
      },
      {
        key: "lazyLoad",
        value: function t() {
          if (
            this.instance.dispatch("contentLazyLoad", { content: this })
              .defaultPrevented
          )
            return;
          this.load(true);
        },
      },
      {
        key: "keepPlaceholder",
        value: function t() {
          return this.instance.applyFilters(
            "isKeepingPlaceholder",
            this.isLoading(),
            this
          );
        },
      },
      {
        key: "destroy",
        value: function t() {
          this.hasSlide = false;
          this.slide = void 0;
          if (
            this.instance.dispatch("contentDestroy", { content: this })
              .defaultPrevented
          )
            return;
          this.remove();
          if (this.placeholder) {
            this.placeholder.destroy();
            this.placeholder = void 0;
          }
          if (this.isImageContent() && this.element) {
            this.element.onload = null;
            this.element.onerror = null;
            this.element = void 0;
          }
        },
      },
      {
        key: "displayError",
        value: function t() {
          if (this.slide) {
            var e, i;
            var n = m("pswp__error-msg", "div");
            n.innerText =
              (e =
                (i = this.instance.options) === null || i === void 0
                  ? void 0
                  : i.errorMsg) !== null && e !== void 0
                ? e
                : "";
            n = this.instance.applyFilters("contentErrorElement", n, this);
            this.element = m("pswp__content pswp__error-msg-container", "div");
            this.element.appendChild(n);
            this.slide.container.innerText = "";
            this.slide.container.appendChild(this.element);
            this.slide.updateContentSize(true);
            this.removePlaceholder();
          }
        },
      },
      {
        key: "append",
        value: function t() {
          var e = this;
          if (this.isAttached || !this.element) return;
          this.isAttached = true;
          if (this.state === z.ERROR) {
            this.displayError();
            return;
          }
          if (
            this.instance.dispatch("contentAppend", { content: this })
              .defaultPrevented
          )
            return;
          var i = "decode" in this.element;
          if (this.isImageContent())
            if (i && this.slide && (!this.slide.isActive || T())) {
              this.isDecoding = true;
              this.element
                .decode()
                ["catch"](function () {})
                ["finally"](function () {
                  e.isDecoding = false;
                  e.appendImage();
                });
            } else this.appendImage();
          else if (this.slide && !this.element.parentNode)
            this.slide.container.appendChild(this.element);
        },
      },
      {
        key: "activate",
        value: function t() {
          if (
            this.instance.dispatch("contentActivate", { content: this })
              .defaultPrevented ||
            !this.slide
          )
            return;
          if (this.isImageContent() && this.isDecoding && !T())
            this.appendImage();
          else if (this.isError()) this.load(false, true);
          if (this.slide.holderElement)
            this.slide.holderElement.setAttribute("aria-hidden", "false");
        },
      },
      {
        key: "deactivate",
        value: function t() {
          this.instance.dispatch("contentDeactivate", { content: this });
          if (this.slide && this.slide.holderElement)
            this.slide.holderElement.setAttribute("aria-hidden", "true");
        },
      },
      {
        key: "remove",
        value: function t() {
          this.isAttached = false;
          if (
            this.instance.dispatch("contentRemove", { content: this })
              .defaultPrevented
          )
            return;
          if (this.element && this.element.parentNode) this.element.remove();
          if (this.placeholder && this.placeholder.element)
            this.placeholder.element.remove();
        },
      },
      {
        key: "appendImage",
        value: function t() {
          if (!this.isAttached) return;
          if (
            this.instance.dispatch("contentAppendImage", { content: this })
              .defaultPrevented
          )
            return;
          if (this.slide && this.element && !this.element.parentNode)
            this.slide.container.appendChild(this.element);
          if (this.state === z.LOADED || this.state === z.ERROR)
            this.removePlaceholder();
        },
      },
    ]);
  })();
  var Zt = 5;
  function Ft(t, e, i) {
    var n = e.createContentFromData(t, i);
    var s;
    var o = e.options;
    if (o) {
      s = new N(o, t, -1);
      var a;
      if (e.pswp) a = e.pswp.viewportSize;
      else a = Z(o, e);
      var r = M(o, a, t, i);
      s.update(n.width, n.height, r);
    }
    n.lazyLoad();
    if (s)
      n.setDisplayedSize(
        Math.ceil(n.width * s.initial),
        Math.ceil(n.height * s.initial)
      );
    return n;
  }
  function Mt(t, e) {
    var i = e.getItemData(t);
    if (e.dispatch("lazyLoadSlide", { index: t, itemData: i }).defaultPrevented)
      return;
    return Ft(i, e, t);
  }
  var Rt = (function () {
    function t(e) {
      c(this, t);
      this.pswp = e;
      this.limit = Math.max(
        e.options.preload[0] + e.options.preload[1] + 1,
        Zt
      );
      this._cachedItems = [];
    }
    return d(t, [
      {
        key: "updateLazy",
        value: function t(e) {
          var i = this.pswp;
          if (i.dispatch("lazyLoad").defaultPrevented) return;
          var n = i.options.preload;
          var s = e === void 0 ? true : e >= 0;
          var o;
          for (o = 0; o <= n[1]; o++)
            this.loadSlideByIndex(i.currIndex + (s ? o : -o));
          for (o = 1; o <= n[0]; o++)
            this.loadSlideByIndex(i.currIndex + (s ? -o : o));
        },
      },
      {
        key: "loadSlideByIndex",
        value: function t(e) {
          var i = this.pswp.getLoopedIndex(e);
          var n = this.getContentByIndex(i);
          if (!n) {
            n = Mt(i, this.pswp);
            if (n) this.addToCache(n);
          }
        },
      },
      {
        key: "getContentBySlide",
        value: function t(e) {
          var i = this.getContentByIndex(e.index);
          if (!i) {
            i = this.pswp.createContentFromData(e.data, e.index);
            this.addToCache(i);
          }
          i.setSlide(e);
          return i;
        },
      },
      {
        key: "addToCache",
        value: function t(e) {
          this.removeByIndex(e.index);
          this._cachedItems.push(e);
          if (this._cachedItems.length > this.limit) {
            var i = this._cachedItems.findIndex(function (t) {
              return !t.isAttached && !t.hasSlide;
            });
            if (i !== -1) {
              var n = this._cachedItems.splice(i, 1)[0];
              n.destroy();
            }
          }
        },
      },
      {
        key: "removeByIndex",
        value: function t(e) {
          var i = this._cachedItems.findIndex(function (t) {
            return t.index === e;
          });
          if (i !== -1) this._cachedItems.splice(i, 1);
        },
      },
      {
        key: "getContentByIndex",
        value: function t(e) {
          return this._cachedItems.find(function (t) {
            return t.index === e;
          });
        },
      },
      {
        key: "destroy",
        value: function t() {
          this._cachedItems.forEach(function (t) {
            return t.destroy();
          });
          this._cachedItems = [];
        },
      },
    ]);
  })();
  var Bt = (function (t) {
    function e() {
      c(this, e);
      return n(this, e, arguments);
    }
    l(e, t);
    return d(e, [
      {
        key: "getNumItems",
        value: function t() {
          var e;
          var i = 0;
          var n =
            (e = this.options) === null || e === void 0 ? void 0 : e.dataSource;
          if (n && "length" in n) i = n.length;
          else if (n && "gallery" in n) {
            if (!n.items) n.items = this._getGalleryDOMElements(n.gallery);
            if (n.items) i = n.items.length;
          }
          var s = this.dispatch("numItems", { dataSource: n, numItems: i });
          return this.applyFilters("numItems", s.numItems, n);
        },
      },
      {
        key: "createContentFromData",
        value: function t(e, i) {
          return new Dt(e, this, i);
        },
      },
      {
        key: "getItemData",
        value: function t(e) {
          var i;
          var n =
            (i = this.options) === null || i === void 0 ? void 0 : i.dataSource;
          var s = {};
          if (Array.isArray(n)) s = n[e];
          else if (n && "gallery" in n) {
            if (!n.items) n.items = this._getGalleryDOMElements(n.gallery);
            s = n.items[e];
          }
          var o = s;
          if (o instanceof Element) o = this._domElementToItemData(o);
          var a = this.dispatch("itemData", { itemData: o || {}, index: e });
          return this.applyFilters("itemData", a.itemData, e);
        },
      },
      {
        key: "_getGalleryDOMElements",
        value: function t(e) {
          var i, n;
          if (
            ((i = this.options) !== null && i !== void 0 && i.children) ||
            ((n = this.options) !== null && n !== void 0 && n.childSelector)
          )
            return (
              O(this.options.children, this.options.childSelector, e) || []
            );
          return [e];
        },
      },
      {
        key: "_domElementToItemData",
        value: function t(e) {
          var i = { element: e };
          var n = e.tagName === "A" ? e : e.querySelector("a");
          if (n) {
            i.src = n.dataset.pswpSrc || n.href;
            if (n.dataset.pswpSrcset) i.srcset = n.dataset.pswpSrcset;
            i.width = n.dataset.pswpWidth
              ? parseInt(n.dataset.pswpWidth, 10)
              : 0;
            i.height = n.dataset.pswpHeight
              ? parseInt(n.dataset.pswpHeight, 10)
              : 0;
            i.w = i.width;
            i.h = i.height;
            if (n.dataset.pswpType) i.type = n.dataset.pswpType;
            var s = e.querySelector("img");
            if (s) {
              var o;
              i.msrc = s.currentSrc || s.src;
              i.alt =
                (o = s.getAttribute("alt")) !== null && o !== void 0 ? o : "";
            }
            if (n.dataset.pswpCropped || n.dataset.cropped)
              i.thumbCropped = true;
          }
          return this.applyFilters("domItemData", i, e, n);
        },
      },
      {
        key: "lazyLoadData",
        value: function t(e, i) {
          return Ft(e, this, i);
        },
      },
    ]);
  })(Tt);
  var Nt = 0.003;
  var Ht = (function () {
    function t(e) {
      c(this, t);
      this.pswp = e;
      this.isClosed = true;
      this.isOpen = false;
      this.isClosing = false;
      this.isOpening = false;
      this._duration = void 0;
      this._useAnimation = false;
      this._croppedZoom = false;
      this._animateRootOpacity = false;
      this._animateBgOpacity = false;
      this._placeholder = void 0;
      this._opacityElement = void 0;
      this._cropContainer1 = void 0;
      this._cropContainer2 = void 0;
      this._thumbBounds = void 0;
      this._prepareOpen = this._prepareOpen.bind(this);
      e.on("firstZoomPan", this._prepareOpen);
    }
    return d(t, [
      {
        key: "open",
        value: function t() {
          this._prepareOpen();
          this._start();
        },
      },
      {
        key: "close",
        value: function t() {
          var e = this;
          if (this.isClosed || this.isClosing || this.isOpening) return;
          var i = this.pswp.currSlide;
          this.isOpen = false;
          this.isOpening = false;
          this.isClosing = true;
          this._duration = this.pswp.options.hideAnimationDuration;
          if (
            i &&
            i.currZoomLevel * i.width >= this.pswp.options.maxWidthToAnimate
          )
            this._duration = 0;
          this._applyStartProps();
          setTimeout(
            function () {
              e._start();
            },
            this._croppedZoom ? 30 : 0
          );
        },
      },
      {
        key: "_prepareOpen",
        value: function t() {
          this.pswp.off("firstZoomPan", this._prepareOpen);
          if (!this.isOpening) {
            var e = this.pswp.currSlide;
            this.isOpening = true;
            this.isClosing = false;
            this._duration = this.pswp.options.showAnimationDuration;
            if (
              e &&
              e.zoomLevels.initial * e.width >=
                this.pswp.options.maxWidthToAnimate
            )
              this._duration = 0;
            this._applyStartProps();
          }
        },
      },
      {
        key: "_applyStartProps",
        value: function t() {
          var e = this.pswp;
          var i = this.pswp.currSlide;
          var n = e.options;
          if (n.showHideAnimationType === "fade") {
            n.showHideOpacity = true;
            this._thumbBounds = void 0;
          } else if (n.showHideAnimationType === "none") {
            n.showHideOpacity = false;
            this._duration = 0;
            this._thumbBounds = void 0;
          } else if (this.isOpening && e._initialThumbBounds)
            this._thumbBounds = e._initialThumbBounds;
          else this._thumbBounds = this.pswp.getThumbBounds();
          this._placeholder =
            i === null || i === void 0 ? void 0 : i.getPlaceholderElement();
          e.animations.stopAll();
          this._useAnimation = Boolean(this._duration && this._duration > 50);
          this._animateZoom =
            Boolean(this._thumbBounds) &&
            (i === null || i === void 0
              ? void 0
              : i.content.usePlaceholder()) &&
            (!this.isClosing || !e.mainScroll.isShifted());
          if (!this._animateZoom) {
            this._animateRootOpacity = true;
            if (this.isOpening && i) {
              i.zoomAndPanToInitial();
              i.applyCurrentZoomPan();
            }
          } else {
            var s;
            this._animateRootOpacity =
              (s = n.showHideOpacity) !== null && s !== void 0 ? s : false;
          }
          this._animateBgOpacity =
            !this._animateRootOpacity && this.pswp.options.bgOpacity > Nt;
          this._opacityElement = this._animateRootOpacity ? e.element : e.bg;
          if (!this._useAnimation) {
            this._duration = 0;
            this._animateZoom = false;
            this._animateBgOpacity = false;
            this._animateRootOpacity = true;
            if (this.isOpening) {
              if (e.element) e.element.style.opacity = String(Nt);
              e.applyBgOpacity(1);
            }
            return;
          }
          if (
            this._animateZoom &&
            this._thumbBounds &&
            this._thumbBounds.innerRect
          ) {
            var o;
            this._croppedZoom = true;
            this._cropContainer1 = this.pswp.container;
            this._cropContainer2 =
              (o = this.pswp.currSlide) === null || o === void 0
                ? void 0
                : o.holderElement;
            if (e.container) {
              e.container.style.overflow = "hidden";
              e.container.style.width = e.viewportSize.x + "px";
            }
          } else this._croppedZoom = false;
          if (this.isOpening) {
            if (this._animateRootOpacity) {
              if (e.element) e.element.style.opacity = String(Nt);
              e.applyBgOpacity(1);
            } else {
              if (this._animateBgOpacity && e.bg)
                e.bg.style.opacity = String(Nt);
              if (e.element) e.element.style.opacity = "1";
            }
            if (this._animateZoom) {
              this._setClosedStateZoomPan();
              if (this._placeholder) {
                this._placeholder.style.willChange = "transform";
                this._placeholder.style.opacity = String(Nt);
              }
            }
          } else if (this.isClosing) {
            if (e.mainScroll.itemHolders[0])
              e.mainScroll.itemHolders[0].el.style.display = "none";
            if (e.mainScroll.itemHolders[2])
              e.mainScroll.itemHolders[2].el.style.display = "none";
            if (this._croppedZoom)
              if (e.mainScroll.x !== 0) {
                e.mainScroll.resetPosition();
                e.mainScroll.resize();
              }
          }
        },
      },
      {
        key: "_start",
        value: function t() {
          var e = this;
          if (
            this.isOpening &&
            this._useAnimation &&
            this._placeholder &&
            this._placeholder.tagName === "IMG"
          )
            new Promise(function (t) {
              var i = false;

              var n = true;
              L(e._placeholder)["finally"](function () {
                i = true;
                if (!n) t(true);
              });
              setTimeout(function () {
                n = false;
                if (i) t(true);
              }, 50);
              setTimeout(t, 250);
            })["finally"](function () {
              return e._initiate();
            });
          else this._initiate();
        },
      },
      {
        key: "_initiate",
        value: function t() {
          var e, i;
          (e = this.pswp.element) === null ||
            e === void 0 ||
            e.style.setProperty(
              "--pswp-transition-duration",
              this._duration + "ms"
            );
          this.pswp.dispatch(
            this.isOpening ? "openingAnimationStart" : "closingAnimationStart"
          );
          this.pswp.dispatch("initialZoom" + (this.isOpening ? "In" : "Out"));
          (i = this.pswp.element) === null ||
            i === void 0 ||
            i.classList.toggle("pswp--ui-visible", this.isOpening);
          if (this.isOpening) {
            if (this._placeholder) this._placeholder.style.opacity = "1";
            this._animateToOpenState();
          } else if (this.isClosing) this._animateToClosedState();
          if (!this._useAnimation) this._onAnimationComplete();
        },
      },
      {
        key: "_onAnimationComplete",
        value: function t() {
          var e = this.pswp;
          this.isOpen = this.isOpening;
          this.isClosed = this.isClosing;
          this.isOpening = false;
          this.isClosing = false;
          e.dispatch(
            this.isOpen ? "openingAnimationEnd" : "closingAnimationEnd"
          );
          e.dispatch("initialZoom" + (this.isOpen ? "InEnd" : "OutEnd"));
          if (this.isClosed) e.destroy();
          else if (this.isOpen) {
            var i;
            if (this._animateZoom && e.container) {
              e.container.style.overflow = "visible";
              e.container.style.width = "100%";
            }
            (i = e.currSlide) === null ||
              i === void 0 ||
              i.applyCurrentZoomPan();
          }
        },
      },
      {
        key: "_animateToOpenState",
        value: function t() {
          var e = this.pswp;
          if (this._animateZoom) {
            if (
              this._croppedZoom &&
              this._cropContainer1 &&
              this._cropContainer2
            ) {
              this._animateTo(
                this._cropContainer1,
                "transform",
                "translate3d(0,0,0)"
              );
              this._animateTo(this._cropContainer2, "transform", "none");
            }
            if (e.currSlide) {
              e.currSlide.zoomAndPanToInitial();
              this._animateTo(
                e.currSlide.container,
                "transform",
                e.currSlide.getCurrentTransform()
              );
            }
          }
          if (this._animateBgOpacity && e.bg)
            this._animateTo(e.bg, "opacity", String(e.options.bgOpacity));
          if (this._animateRootOpacity && e.element)
            this._animateTo(e.element, "opacity", "1");
        },
      },
      {
        key: "_animateToClosedState",
        value: function t() {
          var e = this.pswp;
          if (this._animateZoom) this._setClosedStateZoomPan(true);
          if (this._animateBgOpacity && e.bgOpacity > 0.01 && e.bg)
            this._animateTo(e.bg, "opacity", "0");
          if (this._animateRootOpacity && e.element)
            this._animateTo(e.element, "opacity", "0");
        },
      },
      {
        key: "_setClosedStateZoomPan",
        value: function t(e) {
          if (!this._thumbBounds) return;
          var i = this.pswp;
          var n = this._thumbBounds.innerRect;
          var s = i.currSlide,
            o = i.viewportSize;
          if (
            this._croppedZoom &&
            n &&
            this._cropContainer1 &&
            this._cropContainer2
          ) {
            var a = -o.x + (this._thumbBounds.x - n.x) + n.w;
            var r = -o.y + (this._thumbBounds.y - n.y) + n.h;
            var l = o.x - n.w;
            var h = o.y - n.h;
            if (e) {
              this._animateTo(this._cropContainer1, "transform", x(a, r));
              this._animateTo(this._cropContainer2, "transform", x(l, h));
            } else {
              S(this._cropContainer1, a, r);
              S(this._cropContainer2, l, h);
            }
          }
          if (s) {
            y(s.pan, n || this._thumbBounds);
            s.currZoomLevel = this._thumbBounds.w / s.width;
            if (e)
              this._animateTo(
                s.container,
                "transform",
                s.getCurrentTransform()
              );
            else s.applyCurrentZoomPan();
          }
        },
      },
      {
        key: "_animateTo",
        value: function t(e, i, n) {
          var s = this;
          if (!this._duration) {
            e.style[i] = n;
            return;
          }
          var o = this.pswp.animations;
          var a = {
            duration: this._duration,
            easing: this.pswp.options.easing,
            onComplete: function t() {
              if (!o.activeAnimations.length) s._onAnimationComplete();
            },
            target: e,
          };
          a[i] = n;
          o.startTransition(a);
        },
      },
    ]);
  })();
  var Wt = {
    allowPanToNext: true,
    spacing: 0.1,
    loop: true,
    pinchToClose: true,
    closeOnVerticalDrag: true,
    hideAnimationDuration: 333,
    showAnimationDuration: 333,
    zoomAnimationDuration: 333,
    escKey: true,
    arrowKeys: true,
    trapFocus: true,
    returnFocus: true,
    maxWidthToAnimate: 4e3,
    clickToCloseNonZoomable: true,
    imageClickAction: "zoom-or-close",
    bgClickAction: "close",
    tapAction: "toggle-controls",
    doubleTapAction: "zoom",
    indexIndicatorSep: " / ",
    preloaderDelay: 2e3,
    bgOpacity: 0.8,
    index: 0,
    errorMsg: "The image cannot be loaded",
    preload: [1, 2],
    easing: "cubic-bezier(.4,0,.22,1)",
  };
  var jt = (function (t) {
    function i(t) {
      var e;
      c(this, i);
      e = n(this, i);
      e.options = e._prepareOptions(t || {});
      e.offset = { x: 0, y: 0 };
      e._prevViewportSize = { x: 0, y: 0 };
      e.viewportSize = { x: 0, y: 0 };
      e.bgOpacity = 1;
      e.currIndex = 0;
      e.potentialIndex = 0;
      e.isOpen = false;
      e.isDestroying = false;
      e.hasMouse = false;
      e._initialItemData = {};
      e._initialThumbBounds = void 0;
      e.topBar = void 0;
      e.element = void 0;
      e.template = void 0;
      e.container = void 0;
      e.scrollWrap = void 0;
      e.currSlide = void 0;
      e.events = new D();
      e.animations = new vt();
      e.mainScroll = new ot(e);
      e.gestures = new nt(e);
      e.opener = new Ht(e);
      e.keyboard = new lt(e);
      e.contentLoader = new Rt(e);
      return e;
    }
    l(i, t);
    return d(i, [
      {
        key: "init",
        value: function t() {
          var e = this;
          if (this.isOpen || this.isDestroying) return false;
          this.isOpen = true;
          this.dispatch("init");
          this.dispatch("beforeOpen");
          this._createMainStructure();
          var i = "pswp--open";
          if (this.gestures.supportsTouch) i += " pswp--touch";
          if (this.options.mainClass) i += " " + this.options.mainClass;
          if (this.element) this.element.className += " " + i;
          this.currIndex = this.options.index || 0;
          this.potentialIndex = this.currIndex;
          this.dispatch("firstUpdate");
          this.scrollWheel = new mt(this);
          if (
            Number.isNaN(this.currIndex) ||
            this.currIndex < 0 ||
            this.currIndex >= this.getNumItems()
          )
            this.currIndex = 0;
          if (!this.gestures.supportsTouch) this.mouseDetected();
          this.updateSize();
          this.offset.y = window.pageYOffset;
          this._initialItemData = this.getItemData(this.currIndex);
          this.dispatch("gettingData", {
            index: this.currIndex,
            data: this._initialItemData,
            slide: void 0,
          });
          this._initialThumbBounds = this.getThumbBounds();
          this.dispatch("initialLayout");
          this.on("openingAnimationEnd", function () {
            var t = e.mainScroll.itemHolders;
            if (t[0]) {
              t[0].el.style.display = "block";
              e.setContent(t[0], e.currIndex - 1);
            }
            if (t[2]) {
              t[2].el.style.display = "block";
              e.setContent(t[2], e.currIndex + 1);
            }
            e.appendHeavy();
            e.contentLoader.updateLazy();
            e.events.add(window, "resize", e._handlePageResize.bind(e));
            e.events.add(window, "scroll", e._updatePageScrollOffset.bind(e));
            e.dispatch("bindEvents");
          });
          if (this.mainScroll.itemHolders[1])
            this.setContent(this.mainScroll.itemHolders[1], this.currIndex);
          this.dispatch("change");
          this.opener.open();
          this.dispatch("afterInit");
          return true;
        },
      },
      {
        key: "getLoopedIndex",
        value: function t(e) {
          var i = this.getNumItems();
          if (this.options.loop) {
            if (e > i - 1) e -= i;
            if (e < 0) e += i;
          }
          return b(e, 0, i - 1);
        },
      },
      {
        key: "appendHeavy",
        value: function t() {
          this.mainScroll.itemHolders.forEach(function (t) {
            var e;
            (e = t.slide) === null || e === void 0 || e.appendHeavy();
          });
        },
      },
      {
        key: "goTo",
        value: function t(e) {
          this.mainScroll.moveIndexBy(
            this.getLoopedIndex(e) - this.potentialIndex
          );
        },
      },
      {
        key: "next",
        value: function t() {
          this.goTo(this.potentialIndex + 1);
        },
      },
      {
        key: "prev",
        value: function t() {
          this.goTo(this.potentialIndex - 1);
        },
      },
      {
        key: "zoomTo",
        value: function t() {
          var e;
          var i;
          (i = this.currSlide) === null ||
            i === void 0 ||
            (e = i).zoomTo.apply(e, arguments);
        },
      },
      {
        key: "toggleZoom",
        value: function t() {
          var e;
          (e = this.currSlide) === null || e === void 0 || e.toggleZoom();
        },
      },
      {
        key: "close",
        value: function t() {
          // console.log('test');
          document.querySelector(".pswp").style.display = "none";
          if (!this.opener.isOpen || this.isDestroying) return;
          this.isDestroying = true;
          this.dispatch("close");
          this.events.removeAll();
          this.opener.close();
        },
      },
      {
        key: "destroy",
        value: function t() {
          var e;
          if (!this.isDestroying) {
            this.options.showHideAnimationType = "none";
            this.close();
            return;
          }
          this.dispatch("destroy");
          this._listeners = {};
          if (this.scrollWrap) {
            this.scrollWrap.ontouchmove = null;
            this.scrollWrap.ontouchend = null;
          }
          (e = this.element) === null || e === void 0 || e.remove();
          this.mainScroll.itemHolders.forEach(function (t) {
            var e;
            (e = t.slide) === null || e === void 0 || e.destroy();
          });
          this.contentLoader.destroy();
          this.events.removeAll();
        },
      },
      {
        key: "refreshSlideContent",
        value: function t(e) {
          var i = this;
          this.contentLoader.removeByIndex(e);
          this.mainScroll.itemHolders.forEach(function (t, n) {
            var s, o;
            var a =
              ((s =
                (o = i.currSlide) === null || o === void 0
                  ? void 0
                  : o.index) !== null && s !== void 0
                ? s
                : 0) -
              1 +
              n;
            if (i.canLoop()) a = i.getLoopedIndex(a);
            if (a === e) {
              i.setContent(t, e, true);
              if (n === 1) {
                var r;
                i.currSlide = t.slide;
                (r = t.slide) === null || r === void 0 || r.setIsActive(true);
              }
            }
          });
          this.dispatch("change");
        },
      },
      {
        key: "setContent",
        value: function t(e, i, n) {
          if (this.canLoop()) i = this.getLoopedIndex(i);
          if (e.slide) {
            if (e.slide.index === i && !n) return;
            e.slide.destroy();
            e.slide = void 0;
          }
          if (!this.canLoop() && (i < 0 || i >= this.getNumItems())) return;
          var s = this.getItemData(i);
          e.slide = new H(s, i, this);
          if (i === this.currIndex) this.currSlide = e.slide;
          e.slide.append(e.el);
        },
      },
      {
        key: "getViewportCenterPoint",
        value: function t() {
          return { x: this.viewportSize.x / 2, y: this.viewportSize.y / 2 };
        },
      },
      {
        key: "updateSize",
        value: function t(e) {
          if (this.isDestroying) return;
          var i = Z(this.options, this);
          if (!e && w(i, this._prevViewportSize)) return;
          y(this._prevViewportSize, i);
          this.dispatch("beforeResize");
          y(this.viewportSize, this._prevViewportSize);
          this._updatePageScrollOffset();
          this.dispatch("viewportSize");
          this.mainScroll.resize(this.opener.isOpen);
          if (!this.hasMouse && window.matchMedia("(any-hover: hover)").matches)
            this.mouseDetected();
          this.dispatch("resize");
        },
      },
      {
        key: "applyBgOpacity",
        value: function t(e) {
          this.bgOpacity = Math.max(e, 0);
          if (this.bg)
            this.bg.style.opacity = String(
              this.bgOpacity * this.options.bgOpacity
            );
        },
      },
      {
        key: "mouseDetected",
        value: function t() {
          if (!this.hasMouse) {
            var e;
            this.hasMouse = true;
            (e = this.element) === null ||
              e === void 0 ||
              e.classList.add("pswp--has_mouse");
          }
        },
      },
      {
        key: "_handlePageResize",
        value: function t() {
          var e = this;
          this.updateSize();
          if (/iPhone|iPad|iPod/i.test(window.navigator.userAgent))
            setTimeout(function () {
              e.updateSize();
            }, 500);
        },
      },
      {
        key: "_updatePageScrollOffset",
        value: function t() {
          this.setScrollOffset(0, window.pageYOffset);
        },
      },
      {
        key: "setScrollOffset",
        value: function t(e, i) {
          this.offset.x = e;
          this.offset.y = i;
          this.dispatch("updateScrollOffset");
        },
      },
      {
        key: "_createMainStructure",
        value: function t() {
          this.element = m("pswp", "div");
          this.element.setAttribute("tabindex", "-1");
          this.element.setAttribute("role", "dialog");
          this.template = this.element;
          this.bg = m("pswp__bg", "div", this.element);
          this.scrollWrap = m("pswp__scroll-wrap", "section", this.element);
          this.container = m("pswp__container", "div", this.scrollWrap);
          this.scrollWrap.setAttribute("aria-roledescription", "carousel");
          this.container.setAttribute("aria-live", "off");
          this.container.setAttribute("id", "pswp__items");
          this.mainScroll.appendHolders();
          this.ui = new Ct(this);
          this.ui.init();
          (this.options.appendToEl || document.body).appendChild(this.element);
        },
      },
      {
        key: "getThumbBounds",
        value: function t() {
          return At(
            this.currIndex,
            this.currSlide ? this.currSlide.data : this._initialItemData,
            this
          );
        },
      },
      {
        key: "canLoop",
        value: function t() {
          return this.options.loop && this.getNumItems() > 2;
        },
      },
      {
        key: "_prepareOptions",
        value: function t(i) {
          if (
            window.matchMedia("(prefers-reduced-motion), (update: slow)")
              .matches
          ) {
            i.showHideAnimationType = "none";
            i.zoomAnimationDuration = 0;
          }
          return e(e({}, Wt), i);
        },
      },
    ]);
  })(Bt);
  function Vt(t, e, i) {
    return (
      (e = Kt(e)),
      qt(
        t,
        Gt() ? Reflect.construct(e, i || [], Kt(t).constructor) : e.apply(t, i)
      )
    );
  }
  function qt(t, e) {
    if (e && ("object" == Jt(e) || "function" == typeof e)) return e;
    if (void 0 !== e)
      throw new TypeError(
        "Derived constructors may only return object or undefined"
      );
    return Ut(t);
  }
  function Ut(t) {
    if (void 0 === t)
      throw new ReferenceError(
        "this hasn't been initialised - super() hasn't been called"
      );
    return t;
  }
  function Gt() {
    try {
      var t = !Boolean.prototype.valueOf.call(
        Reflect.construct(Boolean, [], function () {})
      );
    } catch (t) {}
    return (Gt = function e() {
      return !!t;
    })();
  }
  function Kt(t) {
    return (
      (Kt = Object.setPrototypeOf
        ? Object.getPrototypeOf.bind()
        : function (t) {
            return t.__proto__ || Object.getPrototypeOf(t);
          }),
      Kt(t)
    );
  }
  function Xt(t, e) {
    if ("function" != typeof e && null !== e)
      throw new TypeError("Super expression must either be null or a function");
    (t.prototype = Object.create(e && e.prototype, {
      constructor: { value: t, writable: !0, configurable: !0 },
    })),
      Object.defineProperty(t, "prototype", { writable: !1 }),
      e && Yt(t, e);
  }
  function Yt(t, e) {
    return (
      (Yt = Object.setPrototypeOf
        ? Object.setPrototypeOf.bind()
        : function (t, e) {
            return (t.__proto__ = e), t;
          }),
      Yt(t, e)
    );
  }
  function Jt(t) {
    "@babel/helpers - typeof";
    return (
      (Jt =
        "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                "function" == typeof Symbol &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            }),
      Jt(t)
    );
  }
  function Qt(t, e) {
    if (!(t instanceof e))
      throw new TypeError("Cannot call a class as a function");
  }
  function $t(t, e) {
    for (var i = 0; i < e.length; i++) {
      var n = e[i];
      (n.enumerable = n.enumerable || !1),
        (n.configurable = !0),
        "value" in n && (n.writable = !0),
        Object.defineProperty(t, ee(n.key), n);
    }
  }
  function te(t, e, i) {
    return (
      e && $t(t.prototype, e),
      i && $t(t, i),
      Object.defineProperty(t, "prototype", { writable: !1 }),
      t
    );
  }
  function ee(t) {
    var e = ie(t, "string");
    return "symbol" == Jt(e) ? e : e + "";
  }
  function ie(t, e) {
    if ("object" != Jt(t) || !t) return t;
    var i = t[Symbol.toPrimitive];
    if (void 0 !== i) {
      var n = i.call(t, e || "default");
      if ("object" != Jt(n)) return n;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === e ? String : Number)(t);
  }
  /*!
   * PhotoSwipe Lightbox 5.4.4 - https://photoswipe.com
   * (c) 2024 Dmytro Semenov
   */ function ne(t, e, i) {
    var n = document.createElement(e);
    if (t) n.className = t;
    if (i) i.appendChild(n);
    return n;
  }
  function se(t, e, i) {
    var n = "translate3d(".concat(t, "px,").concat(e || 0, "px,0)");
    // if (i !== void 0) n += " scale3d(".concat(i, ",").concat(i, ",1)");
    n += " scale3d(1,1,1)";
    return n;
  }

  // function oe(t, e, i) {
  //   t.style.width = typeof e === "number" ? "".concat(e, "px") : e;
  //   t.style.height = typeof i === "number" ? "".concat(i, "px") : i;
  // }

  function oe(t, e, i) {
    if (window.innerWidth >= 1600) {
      t.style.width = `52.08vw`;
      t.style.height = `35.15vw`;
      t.style.color = `red`;
    } else {
      t.style.width = typeof e === "number" ? "".concat(e, "px") : e;
      t.style.height = typeof i === "number" ? "".concat(i, "px") : i;
    }
  }

  var ae = {
    IDLE: "idle",
    LOADING: "loading",
    LOADED: "loaded",
    ERROR: "error",
  };
  function re(t) {
    return (
      ("button" in t && t.button === 1) ||
      t.ctrlKey ||
      t.metaKey ||
      t.altKey ||
      t.shiftKey
    );
  }
  function le(t, e) {
    var i =
      arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : document;
    var n = [];
    if (t instanceof Element) n = [t];
    else if (t instanceof NodeList || Array.isArray(t)) n = Array.from(t);
    else {
      var s = typeof t === "string" ? t : e;
      if (s) n = Array.from(i.querySelectorAll(s));
    }
    return n;
  }
  function he(t) {
    return typeof t === "function" && t.prototype && t.prototype.goTo;
  }
  function ue() {
    return !!(navigator.vendor && navigator.vendor.match(/apple/i));
  }
  var ce = (function () {
    function t(e, i) {
      Qt(this, t);
      this.type = e;
      this.defaultPrevented = false;
      if (i) Object.assign(this, i);
    }
    return te(t, [
      {
        key: "preventDefault",
        value: function t() {
          this.defaultPrevented = true;
        },
      },
    ]);
  })();
  var pe = (function () {
    function t() {
      Qt(this, t);
      this._listeners = {};
      this._filters = {};
      this.pswp = void 0;
      this.options = void 0;
    }
    return te(t, [
      {
        key: "addFilter",
        value: function t(e, i) {
          var n =
            arguments.length > 2 && arguments[2] !== void 0
              ? arguments[2]
              : 100;
          var s, o, a;
          if (!this._filters[e]) this._filters[e] = [];
          (s = this._filters[e]) === null ||
            s === void 0 ||
            s.push({ fn: i, priority: n });
          (o = this._filters[e]) === null ||
            o === void 0 ||
            o.sort(function (t, e) {
              return t.priority - e.priority;
            });
          (a = this.pswp) === null || a === void 0 || a.addFilter(e, i, n);
        },
      },
      {
        key: "removeFilter",
        value: function t(e, i) {
          if (this._filters[e])
            this._filters[e] = this._filters[e].filter(function (t) {
              return t.fn !== i;
            });
          if (this.pswp) this.pswp.removeFilter(e, i);
        },
      },
      {
        key: "applyFilters",
        value: function t(e) {
          var i = this;
          for (
            var n = arguments.length, s = new Array(n > 1 ? n - 1 : 0), o = 1;
            o < n;
            o++
          )
            s[o - 1] = arguments[o];
          var a;
          (a = this._filters[e]) === null ||
            a === void 0 ||
            a.forEach(function (t) {
              s[0] = t.fn.apply(i, s);
            });
          return s[0];
        },
      },
      {
        key: "on",
        value: function t(e, i) {
          var n, s;
          if (!this._listeners[e]) this._listeners[e] = [];
          (n = this._listeners[e]) === null || n === void 0 || n.push(i);
          (s = this.pswp) === null || s === void 0 || s.on(e, i);
        },
      },
      {
        key: "off",
        value: function t(e, i) {
          var n;
          if (this._listeners[e])
            this._listeners[e] = this._listeners[e].filter(function (t) {
              return i !== t;
            });
          (n = this.pswp) === null || n === void 0 || n.off(e, i);
        },
      },
      {
        key: "dispatch",
        value: function t(e, i) {
          var n = this;
          var s;
          if (this.pswp) return this.pswp.dispatch(e, i);
          var o = new ce(e, i);
          (s = this._listeners[e]) === null ||
            s === void 0 ||
            s.forEach(function (t) {
              t.call(n, o);
            });
          return o;
        },
      },
    ]);
  })();
  var de = (function () {
    function t(e, i) {
      Qt(this, t);
      this.element = ne(
        "pswp__img pswp__img--placeholder",
        e ? "img" : "div",
        i
      );
      if (e) {
        console.log(e, this.element);
        var n = this.element;
        n.decoding = "async";
        n.alt = "";
        n.src = e;
        n.setAttribute("role", "presentation");
        n.setAttribute("rol", "pre");
      }
      this.element.setAttribute("aria-hidden", "true");
    }
    return te(t, [
      {
        key: "setDisplayedSize",
        value: function t(e, i) {
          if (!this.element) return;
          if (this.element.tagName === "IMG") {
            oe(this.element, 250, "auto");
            this.element.style.transformOrigin = "0 0";
            this.element.style.transform = se(0, 0, e / 250);
          } else oe(this.element, e, i);
        },
      },
      {
        key: "destroy",
        value: function t() {
          var e;
          if ((e = this.element) !== null && e !== void 0 && e.parentNode)
            this.element.remove();
          this.element = null;
        },
      },
    ]);
  })();
  var fe = (function () {
    function t(e, i, n) {
      Qt(this, t);
      this.instance = i;
      this.data = e;
      this.index = n;
      this.element = void 0;
      this.placeholder = void 0;
      this.slide = void 0;
      this.displayedImageWidth = 0;
      this.displayedImageHeight = 0;
      this.width = Number(this.data.w) || Number(this.data.width) || 0;
      this.height = Number(this.data.h) || Number(this.data.height) || 0;
      this.isAttached = false;
      this.hasSlide = false;
      this.isDecoding = false;
      this.state = ae.IDLE;
      if (this.data.type) this.type = this.data.type;
      else if (this.data.src) this.type = "image";
      else this.type = "html";
      this.instance.dispatch("contentInit", { content: this });
    }
    return te(t, [
      {
        key: "removePlaceholder",
        value: function t() {
          var e = this;
          if (this.placeholder && !this.keepPlaceholder())
            setTimeout(function () {
              if (e.placeholder) {
                e.placeholder.destroy();
                e.placeholder = void 0;
              }
            }, 1e3);
        },
      },
      {
        key: "load",
        value: function t(e, i) {
          if (this.slide && this.usePlaceholder())
            if (!this.placeholder) {
              var n = this.instance.applyFilters(
                "placeholderSrc",
                this.data.msrc && this.slide.isFirstSlide
                  ? this.data.msrc
                  : false,
                this
              );
              this.placeholder = new de(n, this.slide.container);
            } else {
              var s = this.placeholder.element;
              if (s && !s.parentElement) this.slide.container.prepend(s);
            }
          if (this.element && !i) return;
          if (
            this.instance.dispatch("contentLoad", { content: this, isLazy: e })
              .defaultPrevented
          )
            return;
          if (this.isImageContent()) {
            this.element = ne("pswp__img", "img");
            if (this.displayedImageWidth) this.loadImage(e);
          } else {
            this.element = ne("pswp__content", "div");
            this.element.innerHTML = this.data.html || "";
          }
          if (i && this.slide) this.slide.updateContentSize(true);
        },
      },
      {
        key: "loadImage",
        value: function t(e) {
          var i = this;
          var n, s;
          if (
            !this.isImageContent() ||
            !this.element ||
            this.instance.dispatch("contentLoadImage", {
              content: this,
              isLazy: e,
            }).defaultPrevented
          )
            return;
          var o = this.element;
          this.updateSrcsetSizes();
          if (this.data.srcset) o.srcset = this.data.srcset;
          o.src = (n = this.data.src) !== null && n !== void 0 ? n : "";
          o.alt = (s = this.data.alt) !== null && s !== void 0 ? s : "";
          this.state = ae.LOADING;
          if (o.complete) this.onLoaded();
          else {
            o.onload = function () {
              i.onLoaded();
            };
            o.onerror = function () {
              i.onError();
            };
          }
        },
      },
      {
        key: "setSlide",
        value: function t(e) {
          this.slide = e;
          this.hasSlide = true;
          this.instance = e.pswp;
        },
      },
      {
        key: "onLoaded",
        value: function t() {
          this.state = ae.LOADED;
          if (this.slide && this.element) {
            this.instance.dispatch("loadComplete", {
              slide: this.slide,
              content: this,
            });
            if (
              this.slide.isActive &&
              this.slide.heavyAppended &&
              !this.element.parentNode
            ) {
              this.append();
              this.slide.updateContentSize(true);
            }
            if (this.state === ae.LOADED || this.state === ae.ERROR)
              this.removePlaceholder();
          }
        },
      },
      {
        key: "onError",
        value: function t() {
          this.state = ae.ERROR;
          if (this.slide) {
            this.displayError();
            this.instance.dispatch("loadComplete", {
              slide: this.slide,
              isError: true,
              content: this,
            });
            this.instance.dispatch("loadError", {
              slide: this.slide,
              content: this,
            });
          }
        },
      },
      {
        key: "isLoading",
        value: function t() {
          return this.instance.applyFilters(
            "isContentLoading",
            this.state === ae.LOADING,
            this
          );
        },
      },
      {
        key: "isError",
        value: function t() {
          return this.state === ae.ERROR;
        },
      },
      {
        key: "isImageContent",
        value: function t() {
          return this.type === "image";
        },
      },
      {
        key: "setDisplayedSize",
        value: function t(e, i) {
          if (!this.element) return;
          if (this.placeholder) this.placeholder.setDisplayedSize(e, i);
          if (
            this.instance.dispatch("contentResize", {
              content: this,
              width: e,
              height: i,
            }).defaultPrevented
          )
            return;
          oe(this.element, e, i);
          if (this.isImageContent() && !this.isError()) {
            var n = !this.displayedImageWidth && e;
            this.displayedImageWidth = e;
            this.displayedImageHeight = i;
            if (n) this.loadImage(false);
            else this.updateSrcsetSizes();
            if (this.slide)
              this.instance.dispatch("imageSizeChange", {
                slide: this.slide,
                width: e,
                height: i,
                content: this,
              });
          }
        },
      },
      {
        key: "isZoomable",
        value: function t() {
          return this.instance.applyFilters(
            "isContentZoomable",
            this.isImageContent() && this.state !== ae.ERROR,
            this
          );
        },
      },
      {
        key: "updateSrcsetSizes",
        value: function t() {
          if (!this.isImageContent() || !this.element || !this.data.srcset)
            return;
          var e = this.element;
          var i = this.instance.applyFilters(
            "srcsetSizesWidth",
            this.displayedImageWidth,
            this
          );
          if (
            !e.dataset.largestUsedSize ||
            i > parseInt(e.dataset.largestUsedSize, 10)
          ) {
            e.sizes = i + "px";
            e.dataset.largestUsedSize = String(i);
          }
        },
      },
      {
        key: "usePlaceholder",
        value: function t() {
          return this.instance.applyFilters(
            "useContentPlaceholder",
            this.isImageContent(),
            this
          );
        },
      },
      {
        key: "lazyLoad",
        value: function t() {
          if (
            this.instance.dispatch("contentLazyLoad", { content: this })
              .defaultPrevented
          )
            return;
          this.load(true);
        },
      },
      {
        key: "keepPlaceholder",
        value: function t() {
          return this.instance.applyFilters(
            "isKeepingPlaceholder",
            this.isLoading(),
            this
          );
        },
      },
      {
        key: "destroy",
        value: function t() {
          this.hasSlide = false;
          this.slide = void 0;
          if (
            this.instance.dispatch("contentDestroy", { content: this })
              .defaultPrevented
          )
            return;
          this.remove();
          if (this.placeholder) {
            this.placeholder.destroy();
            this.placeholder = void 0;
          }
          if (this.isImageContent() && this.element) {
            this.element.onload = null;
            this.element.onerror = null;
            this.element = void 0;
          }
        },
      },
      {
        key: "displayError",
        value: function t() {
          if (this.slide) {
            var e, i;
            var n = ne("pswp__error-msg", "div");
            n.innerText =
              (e =
                (i = this.instance.options) === null || i === void 0
                  ? void 0
                  : i.errorMsg) !== null && e !== void 0
                ? e
                : "";
            n = this.instance.applyFilters("contentErrorElement", n, this);
            this.element = ne("pswp__content pswp__error-msg-container", "div");
            this.element.appendChild(n);
            this.slide.container.innerText = "";
            this.slide.container.appendChild(this.element);
            this.slide.updateContentSize(true);
            this.removePlaceholder();
          }
        },
      },
      {
        key: "append",
        value: function t() {
          var e = this;
          if (this.isAttached || !this.element) return;
          this.isAttached = true;
          if (this.state === ae.ERROR) {
            this.displayError();
            return;
          }
          if (
            this.instance.dispatch("contentAppend", { content: this })
              .defaultPrevented
          )
            return;
          var i = "decode" in this.element;
          if (this.isImageContent())
            if (i && this.slide && (!this.slide.isActive || ue())) {
              this.isDecoding = true;
              this.element
                .decode()
                ["catch"](function () {})
                ["finally"](function () {
                  e.isDecoding = false;
                  e.appendImage();
                });
            } else this.appendImage();
          else if (this.slide && !this.element.parentNode)
            this.slide.container.appendChild(this.element);
        },
      },
      {
        key: "activate",
        value: function t() {
          if (
            this.instance.dispatch("contentActivate", { content: this })
              .defaultPrevented ||
            !this.slide
          )
            return;
          if (this.isImageContent() && this.isDecoding && !ue())
            this.appendImage();
          else if (this.isError()) this.load(false, true);
          if (this.slide.holderElement)
            this.slide.holderElement.setAttribute("aria-hidden", "false");
        },
      },
      {
        key: "deactivate",
        value: function t() {
          this.instance.dispatch("contentDeactivate", { content: this });
          if (this.slide && this.slide.holderElement)
            this.slide.holderElement.setAttribute("aria-hidden", "true");
        },
      },
      {
        key: "remove",
        value: function t() {
          this.isAttached = false;
          if (
            this.instance.dispatch("contentRemove", { content: this })
              .defaultPrevented
          )
            return;
          if (this.element && this.element.parentNode) this.element.remove();
          if (this.placeholder && this.placeholder.element)
            this.placeholder.element.remove();
        },
      },
      {
        key: "appendImage",
        value: function t() {
          if (!this.isAttached) return;
          if (
            this.instance.dispatch("contentAppendImage", { content: this })
              .defaultPrevented
          )
            return;
          if (this.slide && this.element && !this.element.parentNode)
            this.slide.container.appendChild(this.element);
          if (this.state === ae.LOADED || this.state === ae.ERROR)
            this.removePlaceholder();
        },
      },
    ]);
  })();
  function ve(t, e) {
    if (t.getViewportSizeFn) {
      var i = t.getViewportSizeFn(t, e);
      if (i) return i;
    }
    return { x: document.documentElement.clientWidth, y: window.innerHeight };
  }
  function me(t, e, i, n, s) {
    var o = 0;
    if (e.paddingFn) o = e.paddingFn(i, n, s)[t];
    else if (e.padding) o = e.padding[t];
    else {
      var a = "padding" + t[0].toUpperCase() + t.slice(1);
      if (e[a]) o = e[a];
    }
    return Number(o) || 0;
  }
  function ye(t, e, i, n) {
    return {
      x: e.x - me("left", t, e, i, n) - me("right", t, e, i, n),
      y: e.y - me("top", t, e, i, n) - me("bottom", t, e, i, n),
    };
  }
  var ge = 4e3;
  var _e = (function () {
    function t(e, i, n, s) {
      Qt(this, t);
      this.pswp = s;
      this.options = e;
      this.itemData = i;
      this.index = n;
      this.panAreaSize = null;
      this.elementSize = null;
      this.fit = 1;
      this.fill = 1;
      this.vFill = 1;
      this.initial = 1;
      this.secondary = 1;
      this.max = 1;
      this.min = 1;
    }
    return te(t, [
      {
        key: "update",
        value: function t(e, i, n) {
          var s = { x: e, y: i };
          this.elementSize = s;
          this.panAreaSize = n;
          var o = n.x / s.x;
          var a = n.y / s.y;
          this.fit = Math.min(1, o < a ? o : a);
          this.fill = Math.min(1, o > a ? o : a);
          this.vFill = Math.min(1, a);
          this.initial = this._getInitial();
          this.secondary = this._getSecondary();
          this.max = Math.max(this.initial, this.secondary, this._getMax());
          this.min = Math.min(this.fit, this.initial, this.secondary);
          if (this.pswp)
            this.pswp.dispatch("zoomLevelsUpdate", {
              zoomLevels: this,
              slideData: this.itemData,
            });
        },
      },
      {
        key: "_parseZoomLevelOption",
        value: function t(e) {
          var i = e + "ZoomLevel";
          var n = this.options[i];
          if (!n) return;
          if (typeof n === "function") return n(this);
          if (n === "fill") return this.fill;
          if (n === "fit") return this.fit;
          return Number(n);
        },
      },
      {
        key: "_getSecondary",
        value: function t() {
          var e = this._parseZoomLevelOption("secondary");
          if (e) return e;
          e = Math.min(1, this.fit * 3);
          if (this.elementSize && e * this.elementSize.x > ge)
            e = ge / this.elementSize.x;
          return e;
        },
      },
      {
        key: "_getInitial",
        value: function t() {
          return this._parseZoomLevelOption("initial") || this.fit;
        },
      },
      {
        key: "_getMax",
        value: function t() {
          return this._parseZoomLevelOption("max") || Math.max(1, this.fit * 4);
        },
      },
    ]);
  })();
  function we(t, e, i) {
    var n = e.createContentFromData(t, i);
    var s;
    var o = e.options;
    if (o) {
      s = new _e(o, t, -1);
      var a;
      if (e.pswp) a = e.pswp.viewportSize;
      else a = ve(o, e);
      var r = ye(o, a, t, i);
      s.update(n.width, n.height, r);
    }
    n.lazyLoad();
    if (s)
      n.setDisplayedSize(
        Math.ceil(n.width * s.initial),
        Math.ceil(n.height * s.initial)
      );
    return n;
  }
  function be(t, e) {
    var i = e.getItemData(t);
    if (e.dispatch("lazyLoadSlide", { index: t, itemData: i }).defaultPrevented)
      return;
    return we(i, e, t);
  }
  var xe = (function (t) {
    function e() {
      Qt(this, e);
      return Vt(this, e, arguments);
    }
    Xt(e, t);
    return te(e, [
      {
        key: "getNumItems",
        value: function t() {
          var e;
          var i = 0;
          var n =
            (e = this.options) === null || e === void 0 ? void 0 : e.dataSource;
          if (n && "length" in n) i = n.length;
          else if (n && "gallery" in n) {
            if (!n.items) n.items = this._getGalleryDOMElements(n.gallery);
            if (n.items) i = n.items.length;
          }
          var s = this.dispatch("numItems", { dataSource: n, numItems: i });
          return this.applyFilters("numItems", s.numItems, n);
        },
      },
      {
        key: "createContentFromData",
        value: function t(e, i) {
          return new fe(e, this, i);
        },
      },
      {
        key: "getItemData",
        value: function t(e) {
          var i;
          var n =
            (i = this.options) === null || i === void 0 ? void 0 : i.dataSource;
          var s = {};
          if (Array.isArray(n)) s = n[e];
          else if (n && "gallery" in n) {
            if (!n.items) n.items = this._getGalleryDOMElements(n.gallery);
            s = n.items[e];
          }
          var o = s;
          if (o instanceof Element) o = this._domElementToItemData(o);
          var a = this.dispatch("itemData", { itemData: o || {}, index: e });
          return this.applyFilters("itemData", a.itemData, e);
        },
      },
      {
        key: "_getGalleryDOMElements",
        value: function t(e) {
          var i, n;
          if (
            ((i = this.options) !== null && i !== void 0 && i.children) ||
            ((n = this.options) !== null && n !== void 0 && n.childSelector)
          )
            return (
              le(this.options.children, this.options.childSelector, e) || []
            );
          return [e];
        },
      },
      {
        key: "_domElementToItemData",
        value: function t(e) {
          var i = { element: e };
          var n = e.tagName === "A" ? e : e.querySelector("a");
          if (n) {
            i.src = n.dataset.pswpSrc || n.href;
            if (n.dataset.pswpSrcset) i.srcset = n.dataset.pswpSrcset;
            i.width = n.dataset.pswpWidth
              ? parseInt(n.dataset.pswpWidth, 10)
              : 0;
            i.height = n.dataset.pswpHeight
              ? parseInt(n.dataset.pswpHeight, 10)
              : 0;
            i.w = i.width;
            i.h = i.height;
            if (n.dataset.pswpType) i.type = n.dataset.pswpType;
            var s = e.querySelector("img");
            if (s) {
              var o;
              i.msrc = s.currentSrc || s.src;
              i.alt =
                (o = s.getAttribute("alt")) !== null && o !== void 0 ? o : "";
            }
            if (n.dataset.pswpCropped || n.dataset.cropped)
              i.thumbCropped = true;
          }
          return this.applyFilters("domItemData", i, e, n);
        },
      },
      {
        key: "lazyLoadData",
        value: function t(e, i) {
          return we(e, this, i);
        },
      },
    ]);
  })(pe);
  var Se = (function (t) {
    function e(t) {
      var i;
      Qt(this, e);
      i = Vt(this, e);
      i.options = t || {};
      i._uid = 0;
      i.shouldOpen = false;
      i._preloadedContent = void 0;
      i.onThumbnailsClick = i.onThumbnailsClick.bind(i);
      return i;
    }
    Xt(e, t);
    return te(e, [
      {
        key: "init",
        value: function t() {
          var e = this;
          le(this.options.gallery, this.options.gallerySelector).forEach(
            function (t) {
              t.addEventListener("click", e.onThumbnailsClick, false);
            }
          );
        },
      },
      {
        key: "onThumbnailsClick",
        value: function t(e) {
          if (re(e) || window.pswp) return;
          var i = { x: e.clientX, y: e.clientY };
          if (!i.x && !i.y) i = null;
          var n = this.getClickedIndex(e);
          n = this.applyFilters("clickedIndex", n, e, this);
          var s = { gallery: e.currentTarget };
          if (n >= 0) {
            e.preventDefault();
            this.loadAndOpen(n, s, i);
          }
        },
      },
      {
        key: "getClickedIndex",
        value: function t(e) {
          if (this.options.getClickedIndexFn)
            return this.options.getClickedIndexFn.call(this, e);
          var i = e.target;
          var n = le(
            this.options.children,
            this.options.childSelector,
            e.currentTarget
          );
          var s = n.findIndex(function (t) {
            return t === i || t.contains(i);
          });
          if (s !== -1) return s;
          else if (this.options.children || this.options.childSelector)
            return -1;
          return 0;
        },
      },
      {
        key: "loadAndOpen",
        value: function t(e, i, n) {
          if (window.pswp || !this.options) return false;
          if (!i && this.options.gallery && this.options.children) {
            var s = le(this.options.gallery);
            if (s[0]) i = { gallery: s[0] };
          }
          this.options.index = e;
          this.options.initialPointerPos = n;
          this.shouldOpen = true;
          this.preload(e, i);
          return true;
        },
      },
      {
        key: "preload",
        value: function t(e, i) {
          var n = this;
          var s = this.options;
          if (i) s.dataSource = i;
          var o = [];
          var a = Jt(s.pswpModule);
          if (he(s.pswpModule)) o.push(Promise.resolve(s.pswpModule));
          else if (a === "string")
            throw new Error("pswpModule as string is no longer supported");
          else if (a === "function") o.push(s.pswpModule());
          else throw new Error("pswpModule is not valid");
          if (typeof s.openPromise === "function") o.push(s.openPromise());
          if (s.preloadFirstSlide !== false && e >= 0)
            this._preloadedContent = be(e, this);
          var r = ++this._uid;
          Promise.all(o).then(function (t) {
            if (n.shouldOpen) {
              var e = t[0];
              n._openPhotoswipe(e, r);
            }
          });
        },
      },
      {
        key: "_openPhotoswipe",
        value: function t(e, i) {
          var n = this;
          if (i !== this._uid && this.shouldOpen) return;
          this.shouldOpen = false;
          if (window.pswp) return;
          var s =
            Jt(e) === "object"
              ? new e["default"](this.options)
              : new e(this.options);
          this.pswp = s;
          window.pswp = s;
          Object.keys(this._listeners).forEach(function (t) {
            var e;
            (e = n._listeners[t]) === null ||
              e === void 0 ||
              e.forEach(function (e) {
                s.on(t, e);
              });
          });
          Object.keys(this._filters).forEach(function (t) {
            var e;
            (e = n._filters[t]) === null ||
              e === void 0 ||
              e.forEach(function (e) {
                s.addFilter(t, e.fn, e.priority);
              });
          });
          if (this._preloadedContent) {
            s.contentLoader.addToCache(this._preloadedContent);
            this._preloadedContent = void 0;
          }
          s.on("destroy", function () {
            n.pswp = void 0;
            delete window.pswp;
          });
          s.init();
        },
      },
      {
        key: "destroy",
        value: function t() {
          var e = this;
          var i;
          (i = this.pswp) === null || i === void 0 || i.destroy();
          this.shouldOpen = false;
          this._listeners = {};
          le(this.options.gallery, this.options.gallerySelector).forEach(
            function (t) {
              t.removeEventListener("click", e.onThumbnailsClick, false);
            }
          );
        },
      },
    ]);
  })(xe);
  window.FoxTheme = window.FoxTheme || {};
  window.FoxTheme.PhotoSwipe = jt;
  window.FoxTheme.PhotoSwipeLightbox = Se;
})();
